import type { NlsStringMap } from '../../strings_nls'
import { enStringsNls } from '../en/strings_nls'

export const esStringsNls = {
  ...enStringsNls,
  NLSWhatsappInviteAction: 'Invitar por WhatsApp',
  NLSWhatsappInviteDialogTitle: 'Invitar por WhatsApp',
  NLSWhatsappInviteDialogCopy: 'Copiar enlace',
  NLSWhatsappInviteDialogShare: 'Compartir',
  NLSWhatsappSendFromMineAction: 'Enviar desde mi WhatsApp',
  NLSWhatsappSendFromMineText: 'Hola {name}, soy {sender} de {workspace}.',
  NLSWhatsappSlipQrCaption: 'Chatea con nosotros en WhatsApp',
  NLSWhatsappChipLinked: 'WhatsApp vinculado',
  NLSWhatsappChipNotYet: 'WhatsApp: aún no',
  NLSWhatsappChipStopped: 'WhatsApp: detenido',
  NLSEduAnnouncementSendWhatsappAction: 'Enviar por WhatsApp',
  NLSEduAnnouncementSendWhatsappDialogTitle: 'Enviar por WhatsApp',
  NLSEduAnnouncementSendWhatsappDialogConfirm: 'Enviar',
  NLSEduAnnouncementSendWhatsappSummaryRecipients: 'Envía a {n} tutores',
  NLSEduAnnouncementSendWhatsappSummaryCredits: 'Envía a {n} tutores · unos {credits} créditos',
  NLSEduAnnouncementSendWhatsappSummaryFree: 'Gratis bajo el límite de tu plan',
  NLSEduAnnouncementSendWhatsappReasonOff: 'WhatsApp está desactivado para este espacio.',
  NLSEduAnnouncementSendWhatsappReasonNotifyOff: 'Envío de anuncios desactivado en la configuración.',
  NLSEduAnnouncementSendWhatsappReasonNoRecipients: 'Sin tutores con consentimiento telefónico verificado.',
  NLSEduAnnouncementSendWhatsappReasonPaused: 'El envío por WhatsApp está pausado por créditos insuficientes.',
  NLSEduAnnouncementSentWhatsappCount: 'Enviado por WhatsApp a {count}',
  NLSCommonRailPageShellSidecarSheet: "Panel de detalles",
  NLSCommonActionBackToWorkspace: 'Volver al espacio',
  NLSCommonActionDownload: 'Descargar',
  NLSCommonActionOpen: 'Abrir',
  NLSCommonActionReloadThisTab: 'Recargar pestaña',
  NLSCommonActionBack: 'Atrás',
  NLSCommonActionCancel: 'Cancelar',
  NLSCommonActionApprove: 'Aprobar',
  NLSCommonActionReject: 'Rechazar',
  NLSCommonActionClose: 'Cerrar',
  NLSCommonActionContinue: 'Continuar',
  NLSCommonActionSignOut: 'Cerrar sesión',
  NLSCommonActionRetryLoadingWorkspaces: 'Reintentar espacios',
  NLSCommonActionRetrying: 'Reintentando...',
  NLSCommonActionMarkUpInDesign: 'Anotar en Diseño',
  NLSCommonAriaAccessDenied: 'Acceso denegado',
  NLSCommonAriaClosePreview: 'Cerrar vista previa',
  NLSCommonAriaConnectionStatus: 'Estado de conexión',
  NLSCommonAriaPreviewAttachment: 'Vista previa de {label}',
  NLSCommonEmptyNoActions: 'Sin acciones',
  NLSCommonEmptyNoOptions: 'Sin opciones',
  NLSCommonErrorGeneric: 'Algo salió mal.',
  NLSCommonInputSearchPlaceholder: 'Buscar',
  NLSCommonInputSearchEllipsisPlaceholder: 'Buscar…',
  NLSCommonInputSearchOptionsPlaceholder: 'Buscar opciones',
  NLSCommonInputSelectPlaceholder: 'Seleccionar',
  NLSCommonInputSelectEllipsisPlaceholder: 'Seleccionar…',
  NLSCommonStatusLoading: 'Cargando',
  NLSCommonStatusSaving: 'Guardando...',
  NLSCommonLanguageAriaLabel: 'Idioma de la app',
  NLSCommonLanguageLabel: 'Idioma',
  NLSCommonAccessDeniedDefaultMessage: 'Tu rol de cuenta no puede acceder a esta área.',
  NLSCommonAccessDeniedTitle: 'Acceso denegado',
  NLSCommonConnectivityDescription: 'La última solicitud falló porque este dispositivo parece estar sin conexión. Vuelve a conectarte y reintenta la acción. Tu espacio sigue abierto debajo.',
  NLSCommonConnectivityEyebrow: 'Conexión interrumpida',
  NLSCommonConnectivityRequestPaused: 'Solicitud pausada',
  NLSCommonConnectivityTitle: 'Timelining no pudo conectar con la red.',
  NLSCommonPreviewAttachmentUnavailable: 'Adjunto no disponible.',
  NLSCommonPreviewFormatUnavailable: 'La vista previa no está disponible para este formato aquí. Aún puedes abrir o descargar el archivo original.',
  NLSCommonPreviewKindAsset: 'Recurso',
  NLSCommonPreviewKindDocument: 'Documento',
  NLSCommonPreviewKindFile: 'Archivo',
  NLSCommonPreviewKindImage: 'Imagen',
  NLSCommonPreviewKindLink: 'Enlace',
  NLSCommonPreviewKindSpreadsheet: 'Hoja',
  NLSCommonPreviewKindTimelineItem: 'Elemento de línea',
  NLSCommonPreviewPreparingText: 'Preparando vista de texto...',
  NLSCommonPreviewTextBlocked: 'La vista de texto está bloqueada para este archivo. Abre o descarga el original.',
  NLSCommonPreviewTextTruncated: 'Vista truncada',
  NLSCommonTabErrorBody: 'El resto de la app está bien. Usa las pestañas inferiores para moverte o intenta recargar esta pestaña.',
  NLSCommonTabErrorTitle: 'Esta pestaña falló',
  NLSSettingsTitleSettings: 'Ajustes',
  NLSSettingsGroupSystem: 'Ajustes del sistema',
  NLSSettingsSectionBilling: 'Facturación',
  NLSSettingsSectionBillingSubtitle: 'Ledger de créditos, saldo del perfil y nivel activo.',
  NLSSettingsCreditPersonalWallet: 'Billetera personal',
  NLSSettingsCreditFilterPurchases: 'Compras',
  NLSSettingsStatusTransactionsPermission: 'No tienes permiso para ver este ledger.',
  NLSProfileStatusNotSet: 'Sin definir',
  NLSProfileLabelDisplayPreference: 'Preferencia de visualización',
  NLSInvitesHubEyebrow: 'Hub de invites',
  NLSInvitesActionNewMemberInvite: 'Nuevo invite de miembro',
  NLSFieldPassStatusExpired: 'Expirado',
  NLSInvitesCategoryMembers: 'Miembros activos',
  NLSFieldPassConfirmRevokeTitle: '¿Revocar este Pase de Campo?',
  NLSFieldPassConfirmRevokeBody: 'El titular actual perderá el acceso inmediatamente. El historial de tareas y chat permanece en el espacio de trabajo.',
  NLSFieldPassConfirmRevokeAction: 'Revocar',
  NLSConfirmActionConfirm: 'Confirmar',
  NLSConfirmActionCancel: 'Cancelar',
  NLSWorkbenchAutomateTitle: 'Automatizar',
  NLSWorkbenchAutomateNavWorkflows: 'Flujos',
  NLSWorkbenchAutomateChipNeedsAttention: 'Requiere atención',
  NLSWorkbenchDesignNavBound: 'Estudio Bound',
  NLSWorkbenchExploreSearchPublic: 'Buscar espacios públicos',
  NLSWorkbenchOverviewModeTeam: 'Equipo',
  NLSWorkbenchFocusFreeformTitle: 'Focus libre',
  NLSWorkbenchFocusSoundSilence: 'Silencio profundo',
  NLSExperienceYourPageEyebrow: 'Tu página',
  NLSExperienceYourTabAchievements: 'Logros',
  NLSExperienceRarityLegendary: 'Legendario',
  NLSExperienceSpinTierLucky: 'Suerte',
  NLSExperienceFilterClaimable: 'Por reclamar',
  NLSExperienceSpinVaultTitle: 'Vault de giros',
  NLSExperienceMasteryTracksTitle: 'Rutas de maestría',
  NLSExperienceGuardianSanctum: 'Santuario guardián',
  NLSExperienceNotificationSignalStream: 'Flujo de señales',
  NLSExperienceNotificationsTitle: 'Notificaciones',
  NLSExperienceNotificationGroupToday: 'Hoy',
  NLSExperienceNotificationRelativeYesterday: 'ayer',
  NLSExperienceRaidArenaWarRoom: 'Sala de guerra',
  NLSExperienceRaidForgeBoss: 'Forjar jefe',
  NLSExperienceDebugCapture: 'Captura debug',
  NLSExperienceDebugEndTitle: 'Finalizar modo debug',
  NLSAuthEyebrowCloudWorkspace: 'Espacio en la nube',
  NLSAuthEyebrowHelperAccess: 'Acceso helper',
  NLSAuthTitleCloudWorkspace: 'Ordena tus metas. O las de tu equipo.',
  NLSAuthTitleHelperPhone: 'Inicia sesión con tu teléfono.',
  NLSAuthBodyCloudWorkspace: 'Inicia sesión para crear espacios privados o compartidos, generar planes con IA y mantener todo sincronizado.',
  NLSAuthBodyHelperPhone: 'Ingresa el teléfono que registró tu admin. Recibirás un código de verificación por SMS.',
  NLSAuthActionCheckSession: 'Revisar sesión',
  NLSAuthActionContinueGoogle: 'Continuar con Google',
  NLSAuthActionOpeningGoogle: 'Abriendo Google...',
  NLSAuthActionSendOtp: 'Enviar OTP',
  NLSAuthActionSendingOtp: 'Enviando OTP...',
  NLSAuthActionVerifySignIn: 'Verificar e ingresar',
  NLSAuthActionVerifying: 'Verificando...',
  NLSAuthActionUseDifferentNumber: 'Usar otro número',
  NLSAuthFieldPhoneNumber: 'Teléfono',
  NLSAuthFieldVerificationCode: 'Código',
  NLSAuthErrorChoosePhone: 'Elige un código de país e ingresa los dígitos del número de teléfono.',
  NLSAuthErrorSendOtp: 'No se pudo enviar el OTP. Inténtalo de nuevo.',
  NLSAuthErrorEnterOtp: 'Introduce el OTP numérico que recibiste.',
  NLSAuthErrorInvalidOtp: 'OTP inválido. Inténtalo de nuevo.',
  NLSAuthErrorGoogleSignIn: 'No se pudo iniciar sesión. Inténtalo de nuevo.',
  NLSOnboardingAriaWorkspaceSetup: 'Configuración del espacio de trabajo',
  NLSOnboardingDialogTeamSetup: 'Configura tu nuevo espacio de trabajo',
  NLSOnboardingDialogPersonalSetup: 'Configura tu Espacio Personal',
  NLSOnboardingEyebrowNewSpace: 'Un espacio te espera',
  NLSOnboardingEyebrowWorkspaceSetup: 'Configuración del espacio de trabajo',
  NLSOnboardingTitleBegin: '¿Dónde quieres comenzar?',
  NLSOnboardingTitleSwitchSetup: 'Elige una configuración disponible.',
  NLSOnboardingLedeOwnership: 'Una cuenta puede poseer un Espacio Personal y un espacio de trabajo de Equipo. Las invitaciones y solicitudes de equipo público se mantienen separadas.',
  NLSOnboardingPersonalEyebrow: 'Solo · privado',
  NLSOnboardingPersonalTitle: 'Espacio personal',
  NLSOnboardingPersonalDescription: 'Un lienzo en blanco para tus metas, planes y líneas de tiempo generadas por IA. Nadie lo ve excepto tú.',
  NLSOnboardingActionLaunchPersonal: 'Abrir espacio personal',
  NLSOnboardingTeamEyebrowCreate: 'Colaborar · público o privado',
  NLSOnboardingTeamEyebrowAccess: 'Invitaciones · equipos públicos',
  NLSOnboardingTeamTitleCreate: 'Espacio de equipo',
  NLSOnboardingTeamTitleAccess: 'Acceso al equipo',
  NLSOnboardingTeamDescriptionCreate: 'Únete por invitación, solicita acceso a un equipo público o funda tu único espacio de trabajo de Equipo.',
  NLSOnboardingTeamDescriptionAccess: 'Ya posees un espacio de trabajo de Equipo. Aún puedes aceptar invitaciones o solicitar acceso a equipos propiedad de otros.',
  NLSOnboardingActionExploreTeam: 'Explorar equipos',
  NLSOnboardingActionViewInvitesTeams: 'Ver invitaciones y equipos públicos',
  NLSOnboardingInviteWaiting: '{count} invitación esperando',
  NLSOnboardingInvitesWaiting: '{count} invitaciones esperando',
  NLSOnboardingFootnoteNoSetups: 'Ya posees tu Espacio Personal y espacio de trabajo de Equipo. Usa invitaciones o solicitudes de equipo público para acceder a equipos propiedad de otros.',
  NLSOnboardingFootnoteOwnershipCap: 'Límite de propiedad: un Espacio Personal y un espacio de trabajo de Equipo por cuenta.',
  NLSOnboardingTeamStageEyebrow: 'Espacios de trabajo en equipo',
  NLSOnboardingTeamStageTitle: 'Únete a un equipo, descubre uno público o funda el tuyo propio.',
  NLSOnboardingTabInvites: 'Invitaciones',
  NLSOnboardingTabDiscover: 'Descubrir',
  NLSOnboardingTabCreateNew: 'Crear',
  NLSOnboardingEmptyNoInvitesTitle: 'Sin invitaciones por ahora',
  NLSOnboardingEmptyNoInvitesForEmail: 'Mostraremos cualquier invitación enviada a {email} aquí.',
  NLSOnboardingEmptySignInInvites: 'Inicia sesión para ver las invitaciones dirigidas a ti.',
  NLSOnboardingSearchPublicTeamsPlaceholder: 'Buscar equipos públicos por nombre',
  NLSOnboardingActionAccept: 'Aceptar',
  NLSOnboardingActionDecline: 'Rechazar',
  NLSOnboardingActionEnter: 'Entrar',
  NLSOnboardingActionRequested: 'Solicitado',
  NLSOnboardingActionRequestAccess: 'Solicitar acceso',
  NLSShellRailSectionBoard: 'Tablero',
  NLSShellRailSectionControls: 'Controles',
  NLSShellRailDays: 'días',
  NLSShellRailPersonalWallet: 'Billetera personal',
  NLSShellRailOpenYourDetails: 'Abre tus detalles',
  NLSShellRailPinSideNav: 'Fijar navegación lateral',
  NLSShellRailUnpinSideNav: 'Desfijar navegación lateral',
  NLSShellRailExpandSideNav: 'Expandir navegación lateral',
  NLSShellRailTileDashboard: 'Panel',
  NLSShellRailTileOverview: 'Visión general',
  NLSShellRailTileCalendar: 'Calendario',
  NLSShellRailTileMeetings: 'Reuniones',
  NLSShellRailTileTodos: 'Tareas',
  NLSShellRailTileChecklists: 'Listas de verificación',
  NLSShellRailTileForms: 'Formularios',
  NLSShellRailTileDesignHub: 'Centro de diseño',
  NLSShellRailTileUpload: 'Cargar',
  NLSShellRailTileMembers: 'Miembros',
  NLSShellRailTileLedger: 'Libro mayor',
  NLSShellRailTileAnalysis: 'Análisis',
  NLSShellRailTileReports: 'Informes',
  NLSShellRailTileLink: 'Enlace',
  NLSShellRailTileStock: 'Existencias',
  NLSShellRailTileBudget: 'Presupuesto',
  NLSShellRailTileQuota: 'Cuota',
  NLSShellRailTileAutomate: 'Automatizar',
  NLSShellRailTileManage: 'Gestionar',
  NLSShellRailTileSettings: 'Ajustes',
  NLSShellRailTileRaid: 'Incursión',
  NLSShellRailTileFocus: 'Enfoque',
  NLSShellRailTileYourPage: 'Tu Página',
  NLSShellRailTileExplore: 'Explorar',
  NLSShellRailTilePurchase: 'Compra',
  NLSShellRailTileNotifications: 'Notificaciones',
  NLSShellRailTileLogOut: 'Salir',
  NLSShellRailShortDashboard: 'Panel',
  NLSShellRailShortOverview: 'Acerca de',
  NLSShellRailShortMeetings: 'Reunión',
  NLSShellRailShortTodos: 'Tarea',
  NLSShellRailShortChecklists: 'Lista',
  NLSShellRailTitleWorkspaceOverview: 'Visión general del espacio de trabajo',
  NLSShellRailTitleVideoCommandHub: 'Centro de comando de video',
  NLSShellRailTitleAutomatedIntake: 'Motor de admisión automatizado',
  NLSShellRailTitleDesignFactory: 'Fábrica de activos visuales',
  NLSShellRailTitleWorkspaceUploads: 'Cargas del espacio de trabajo',
  NLSShellRailTitleWorkspaceIntegrations: 'Integraciones del espacio de trabajo',
  NLSShellRailTitleOperationalStock: 'Existencias y recursos operativos',
  NLSShellRailTitleWorkspaceBudget: 'Centro de presupuesto del espacio de trabajo',
  NLSShellRailTitlePerformanceQuotas: 'Cuotas de rendimiento',
  NLSShellRailTitleWorkflowAutomation: 'Motor de automatización de flujos de trabajo',
  NLSShellRailTitleWorkspaceSettings: 'Configuraciones del espacio de trabajo',
  NLSShellRailTitleHorizonFocus: 'Cámara de enfoque de horizonte',
  NLSShellRailTitleUserSettings: 'Configuraciones del usuario',
  NLSDashboardViewTimeline: 'Línea de tiempo',
  NLSDashboardViewConstellation: 'Constelación',
  NLSDashboardViewSandfall: 'Cascada de arena',
  NLSDashboardViewJourney: 'Ruta',
  NLSDashboardViewGrid: 'Cuadrícula',
  NLSDashboardViewHeatmap: 'Mapa de calor',
  NLSDashboardViewStripboard: 'Tablero de tiras',
  NLSDashboardViewWarRoom: 'Sala de mando',
  NLSDashboardViewReliability: 'Confiabilidad',
  NLSDashboardViewPerimeter: 'Perímetro',
  NLSDashboardViewLootDrop: 'Recompensas',
  NLSDashboardViewFlowband: 'Banda de flujo',
  NLSDashboardViewBurnshore: 'Quema de orilla',
  NLSDashboardViewCadence: 'Cadencia',
  NLSDashboardViewTooltipTimeline: 'Plan cronológico con desplazamiento, zoom y pings de cursor.',
  NLSDashboardViewTooltipConstellation: 'Nodos interactivos y conexiones que muestran cómo el trabajo depende de otro trabajo.',
  NLSDashboardViewTooltipRadar: 'Radar que revela los elementos más urgentes en la ventana actual.',
  NLSDashboardViewTooltipSandfall: 'Desglose ponderado del trabajo restante a medida que drena de arriba hacia abajo.',
  NLSDashboardViewTooltipJourney: 'Camino guiado a través del plan con paradas en hitos.',
  NLSDashboardViewTooltipGrid: 'Cuadrícula de contribuciones por día, coloreada por actividad.',
  NLSDashboardViewTooltipHeatmap: 'Mapa de calor de contribuciones agrupado por semana, coloreado por actividad.',
  NLSDashboardViewTooltipStripboard: 'Tira Kanban de elementos de lista de verificación agrupados por estado de flujo de trabajo.',
  NLSDashboardViewTooltipWarRoom: 'Diseño de plano que muestra propietarios y bloqueadores del trabajo activo.',
  NLSDashboardViewTooltipReliability: 'Clasificación de fiabilidad de colaboradores en la ventana actual.',
  NLSDashboardViewTooltipPerimeter: 'Cuenta regresiva de elementos que se acercan a su perímetro de fecha de vencimiento.',
  NLSDashboardViewTooltipLootDrop: 'Secuencia de carriles que liberan ganancias en la ventana actual.',
  NLSDashboardViewTooltipFlowband: 'Participación del peso restante por padre, a lo largo del tiempo.',
  NLSDashboardViewTooltipBurnshore: 'Desglose ponderado por padre, con ocurrencias de listas de verificación.',
  NLSDashboardViewTooltipCadence: 'Distribución del tiempo de finalización entre cubos fijos.',
  NLSDashboardActionGhostEcho: 'Eco Fantasma',
  NLSDashboardActionWatch: 'Vigilar',
  NLSDashboardActionWatching: 'Vigilando',
  NLSDashboardActionStopWatching: 'Dejar de vigilar',
  NLSDashboardActionWatchingStopHint: 'Vigilando - haz clic para detener',
  NLSDashboardActionSendBoardToMobile: 'Enviar vista del tablero a móvil',
  NLSDashboardActionGhostEchoBoardToMobile: 'Eco Fantasma del tablero a móvil',
  NLSDashboardPromptGhostEchoUid: 'Enviar Eco Fantasma al usuario UID:',
  NLSDashboardSenderDesktopFallback: 'Escritorio',
  NLSDashboardActionGhostEchoToMobile: 'Eco Fantasma a móvil',
  NLSDashboardToastGhostEchoSent: 'Eco Fantasma enviado.',
  NLSDashboardToastGhostEchoFailed: 'No se pudo enviar el Eco Fantasma.',
  NLSDashboardActionSendSelectedToMobile: 'Enviar ítem seleccionado a móvil',
  NLSDashboardActionScrollLeftLarge: 'Desplazar mucho a la izquierda',
  NLSDashboardActionScrollLeft: 'Desplazar izquierda',
  NLSDashboardActionScrollRight: 'Desplazar derecha',
  NLSDashboardActionScrollRightLarge: 'Desplazar mucho a la derecha',
  NLSDashboardActionZoomOut: 'Alejar',
  NLSDashboardActionZoomIn: 'Acercar',
  NLSDashboardActionFitFullTimeline: 'Ajustar línea',
  NLSDashboardActionFocusSelectedItem: 'Enfocar seleccionado',
  NLSDashboardActionViewLegend: 'Leyenda',
  NLSDashboardActionShowViewLegend: 'Mostrar leyenda',
  NLSDashboardActionHideViewLegend: 'Ocultar leyenda',
  NLSDashboardActionExpandDashboardView: 'Expandir vista',
  NLSDashboardActionExitExpandedView: 'Salir de vista ampliada',
  NLSDashboardActionCopyItem: 'Copiar ítem',
  NLSDashboardActionCutItem: 'Cortar ítem',
  NLSDashboardActionPasteItem: 'Pegar',
  NLSDashboardActionPasteIntoSelectedItem: 'Pegar en el ítem seleccionado',
  NLSDashboardActionMoveHere: 'Mover aquí',
  NLSDashboardActionPasteCopy: 'Pegar copia',
  NLSDashboardActionMoveGoalToVisionboard: 'Mover meta al Tablero de Visión',
  NLSDashboardActionMoveToVisionboard: 'Mover al Tablero de Visión',
  NLSDashboardActionMoveGoalToArchive: 'Mover meta al Archivo',
  NLSDashboardActionMoveToArchive: 'Mover al Archivo',
  NLSDashboardActionMoveGoalToBin: 'Mover meta al Contenedor',
  NLSDashboardActionMoveToBin: 'Mover al Contenedor',
  NLSDashboardActionWorking: 'Trabajando...',
  NLSDashboardActionConfirm: 'Confirmar',
  NLSDashboardAriaViewSelect: 'Vista del panel',
  NLSDashboardAriaTimelineBreadcrumb: 'Migaja de pan de la línea de tiempo',
  NLSDashboardAriaBoard: 'tablero',
  NLSDashboardAriaGoal: 'meta',
  NLSDashboardAriaTask: 'tarea',
  NLSDashboardAriaSubtask: 'subtarea',
  NLSDashboardAriaMemberViewControls: 'Controles de vista del tablero de miembros',
  NLSDashboardAriaDashboardZoom: 'Zoom del panel',
  NLSDashboardMemberCommandStripAria: 'Tira de comandos del tablero',
  NLSDashboardMemberViewRailAria: 'Selector de vista del tablero',
  NLSDashboardMemberViewPillAria: 'Mostrar vista {view}',
  NLSDashboardMemberGestureDockAria: 'Acoplamiento de zoom del tablero',
  NLSDashboardMemberEnterLandscape: 'Modo paisaje',
  NLSDashboardMemberPeekOpenAria: 'Mostrar resumen del tablero',
  NLSDashboardMemberPeekCloseAria: 'Ocultar resumen del tablero',
  NLSDashboardMemberPeekHandle: 'Resumen',
  NLSDashboardMemberPeekEmpty: 'Ningún ítem seleccionado',
  NLSDashboardMemberPeekSectionSelected: 'Seleccionado',
  NLSDashboardMemberPeekSectionInWindow: 'En vista',
  NLSDashboardMemberPeekSectionReadiness: 'Atención a recursos',
  NLSDashboardMemberPeekCounts: '{goals} metas · {tasks} tareas · {subtasks} subtareas',
  NLSDashboardMemberPeekOpenItem: 'Abrir ítem',
  NLSDashboardAriaDashboardViewControls: 'Controles de vista del panel',
  NLSDashboardAriaDashboardVisualView: 'Vista visual del tablero',
  NLSDashboardAriaCurrentViewControls: 'Controles de vista {view}',
  NLSDashboardAriaPanControls: 'Controles de paneo',
  NLSDashboardAriaZoomControls: 'Controles de zoom',
  NLSDashboardAriaFocusControls: 'Controles de enfoque',
  NLSDashboardAriaPanForwardControls: 'Controles de avance',
  NLSDashboardAriaStageControls: 'Controles de etapa',
  NLSDashboardAriaSelectedItemDetails: 'Detalles del ítem seleccionado',
  NLSDashboardAriaItemDateRange: 'Rango de fechas del ítem',
  NLSDashboardAriaDetailActions: 'Acciones de detalle',
  NLSDashboardAriaShare: 'Compartir',
  NLSDashboardAriaClipboard: 'Portapapeles',
  NLSDashboardAriaBoards: 'Tableros',
  NLSDashboardAriaCurrentZoomPercent: 'Zoom actual {percent} por ciento',
  NLSDashboardStatusLoadingCanvas: 'Cargando lienzo...',
  NLSDashboardStatusDaySpan: 'Rango de {days}d',
  NLSDashboardEmptyNoDescription: 'Aún sin descripción',
  NLSDashboardEmptyNoDate: 'Sin fecha',
  NLSDashboardDetailTypeSubtask: 'Subtarea',
  NLSDashboardDetailTypeGoal: 'Meta',
  NLSDashboardDetailTypeTask: 'Tarea',
  NLSDashboardDetailStart: 'Inicio',
  NLSDashboardDetailEnd: 'Fin',
  NLSDashboardDialogPasteTitle: '¿Pegar {title}?',
  NLSDashboardDialogPastePrefix: 'Esto {action}',
  NLSDashboardDialogPasteActionMove: 'moverá',
  NLSDashboardDialogPasteActionCopy: 'copiará',
  NLSDashboardDialogPasteWithSubtasks: ' con sus subtareas',
  NLSDashboardDialogPasteInto: 'en',
  NLSDashboardDialogPasteSuffix: 'mientras se preserva la jerarquía válida de Meta -> Tarea -> Subtarea.',
  NLSDashboardDialogMoveVisionboardTitle: '¿Mover {title} a Visionboard?',
  NLSDashboardDialogMoveVisionboardMessage: 'Esto moverá la meta y todas las tareas internas, subtareas y elementos de lista de verificación a Visionboard.',
  NLSDashboardDialogMoveArchiveTitle: '¿Mover {title} a Archivo?',
  NLSDashboardDialogMoveArchiveMessage: 'Esto moverá la meta y todas las tareas internas, subtareas y elementos de lista de verificación a Archivo.',
  NLSDashboardDialogMoveBinTitle: '¿Mover {title} a Contenedor?',
  NLSDashboardDialogMoveBinMessage: 'Esto moverá la meta y todas las tareas internas, subtareas y elementos de lista de verificación al Contenedor. Si se elimina del Contenedor más tarde, el árbol de ítems se eliminará permanentemente.',
  NLSDashboardLegendSummary: '{goals} metas · {tasks} tareas · {subtasks} subtareas',
  NLSDashboardLegendWindow: 'Ventana',
  NLSDashboardLegendViewWindow: 'Ventana de vista',
  NLSDashboardLegendToday: 'hoy {date}',
  NLSDashboardLegendHighRiskSignal: '{count} señal de alto riesgo',
  NLSDashboardLegendHighRiskSignals: '{count} señales de alto riesgo',
  NLSDashboardLegendRadarInnerOuter: 'Interior = urgente · exterior = distante',
  NLSDashboardLegendAnglePosition: 'Ángulo = posición en ventana de vista',
  NLSDashboardLegendRadarTodaySweep: 'Línea ámbar = hoy · barrido cian = escaneo en vivo',
  NLSDashboardLegendJourneyPath: 'Camino = metas en orden temporal',
  NLSDashboardLegendAmberLineToday: 'Línea ámbar = hoy',
  NLSDashboardLegendDotsTasksSubtasks: 'Puntos = tareas / subtareas por tiempo',
  NLSDashboardLegendGridCell: 'Celda = día · color = elemento',
  NLSDashboardLegendGridFrame: 'Marco = alcance de perforación',
  NLSDashboardLegendGridSkySpine: 'Columna vertebral = semana actual',
  NLSDashboardLegendGridStripes: 'Rayas = ítems superpuestos',
  NLSDashboardLegendConstellationRing: 'Anillo = ventana de vista · arco = meta en vista',
  NLSDashboardLegendConstellationAmberTick: 'Marca ámbar = hoy',
  NLSDashboardLegendColorSize: 'Color = elemento · tamaño = nivel',
  NLSDashboardLegendDiamondChecklist: 'Diamante = lista de verificación (verde = hecho)',
  NLSDashboardLegendSkyGlowSelected: 'Brillo del cielo = seleccionado',
  NLSDashboardEmptyAiMagicReady: 'AI Magic está listo',
  NLSDashboardEmptyWelcomePhraseStart: 'Comienza con Timelining',
  NLSDashboardEmptyWelcomePhraseCreate: 'Crea líneas fácilmente',
  NLSDashboardEmptyWelcomePhraseManage: 'Gestiona calendarios distinto',
  NLSDashboardEmptyWelcomePhraseMotion: 'Convierte planes en acción',
  NLSDashboardEmptyAiMagicCopy: 'Abre AI Magic desde la navegación lateral para describir un plan y generar metas, tareas, subtareas y fechas.',
  NLSDashboardTimelineMarkerWeek: 'Semana {week}',
  NLSDashboardCanvasSelectedSubtask: 'Subtarea seleccionada',
  NLSDashboardCanvasSubtasksAcrossTask: '{count} subtareas en esta tarea',
  NLSDashboardCanvasTasksAcrossGoal: '{count} tareas en esta meta',
  NLSManageActionApplyAndClose: 'Aplicar y cerrar',
  NLSManageActionApplyStayOpen: 'Aplicar y seguir',
  NLSManageActionClose: 'Cerrar',
  NLSManageActionCopy: 'Copiar',
  NLSManageActionCut: 'Cortar',
  NLSManageActionDelete: 'Eliminar',
  NLSManageActionDeleteForever: 'Eliminar siempre',
  NLSManageActionDiscard: 'Descartar',
  NLSManageActionDiscardAll: 'Descartar todo',
  NLSManageActionDiscardAllUnsaved: 'Descartar pendientes',
  NLSManageActionDiscardAndClose: 'Descartar y cerrar',
  NLSManageActionDrop: 'Quitar',
  NLSManageActionKeepEditing: 'Seguir editando',
  NLSManageActionMove: 'Mover',
  NLSManageActionMoving: 'Moviendo',
  NLSManageActionMoveToBin: 'Mover a Bin',
  NLSManageActionPaste: 'Pegar',
  NLSManageActionPermanentlyDelete: 'Eliminar siempre',
  NLSManageActionSave: 'Guardar',
  NLSManageActionSaveAll: 'Guardar todo',
  NLSManageActionSaveAllChildItems: 'Guardar hijos',
  NLSManageActionSaveToBin: 'Guardar en Bin',
  NLSManageActionYesSure: 'Sí, seguro',
  NLSManageAriaBoard: 'Tablero de Manage',
  NLSManageAriaClipboard: 'Portapapeles',
  NLSManageAriaPageControls: 'Controles de Manage',
  NLSManageAriaSave: 'Guardar',
  NLSManageAriaSaveOptions: 'Opciones de guardar',
  NLSManageAriaDiscard: 'Descartar',
  NLSManageAriaDiscardOptions: 'Opciones de descarte',
  NLSManageAriaPerItemActionFor: 'Acción para {title}',
  NLSManageAriaSwitchView: 'Cambiar vista de Gestión',
  NLSManageAriaWorkspace: 'Espacio Manage',
  NLSManageBinMoveBody: 'Restaurar {title} ({type}) a otro tablero.',
  NLSManageBinMoveEmpty: 'Todavía no hay {typePlural} en este tablero. Elige otro tablero o crea uno primero.',
  NLSManageBinMoveHintGoalsRoot: 'Las metas aterrizan en la raíz del tablero elegido.',
  NLSManageBinMoveParentLabel: 'Padre {type} en este tablero',
  NLSManageBinMovePickParentToast: 'Elige un padre en el tablero elegido.',
  NLSManageBinMoveSelectAria: 'Selecciona un {type} para restaurar debajo',
  NLSManageBinMoveSelectPlaceholder: 'Selecciona un {type}...',
  NLSManageBinMoveTitle: 'Mover fuera del Contenedor',
  NLSManageBoardArchive: 'Archivo',
  NLSManageBoardBin: 'Contenedor',
  NLSManageBoardDashboard: 'Panel',
  NLSManageDialogDiscardAllSessionBody: 'Todos los cambios pendientes se revertirán Y los ítems ya comprometidos durante esta sesión de Gestión se revertirán en Firestore. Esto no se puede deshacer.',
  NLSManageDialogDiscardAllSessionTitle: '¿Descartar todo incluido lo guardado en esta sesión?',
  NLSManageDialogDiscardAllUnsavedBody: 'Todos los cambios no guardados en Gestión se revertirán. Los ítems ya guardados durante esta sesión mantendrán su estado comprometido.',
  NLSManageDialogDiscardAllUnsavedTitle: '¿Descartar todos los cambios pendientes?',
  NLSManageDialogDiscardSelfBody: 'Los cambios pendientes en este {noun} se revertirán al estado anterior.{cascadeNote}',
  NLSManageDialogDiscardSelfCascadeGoal: ' Esto también eliminará todas las tareas y subtareas debajo de él.',
  NLSManageDialogDiscardSelfCascadeTask: ' Esto también eliminará todas las subtareas debajo de él.',
  NLSManageDialogDiscardSelfTitle: '¿Descartar este {noun}?',
  NLSManageDialogDiscardUnsavedBody: 'Tienes {count} {noun} no guardado que no está marcado para guardar. Si cierras ahora, se revertirán a su estado anterior. Los ítems marcados permanecerán guardados.',
  NLSManageDialogDiscardUnsavedTitle: '¿Descartar cambios no guardados?',
  NLSManageDialogPerItemBody: 'Agregaste {count} nuevo {noun} pero nunca hiciste clic en Guardar. Elige qué debe suceder al cerrar: el cierre no procederá hasta que cada fila tenga una elección.',
  NLSManageDialogPerItemTitle: '¿Qué hacemos con estos pendientes?',
  NLSManageDialogPermanentDeleteBody: 'Esto eliminará el ítem y todo lo que hay dentro de Firestore. La acción no se puede deshacer, no volverá al Contenedor.',
  NLSManageDialogPermanentDeleteTitle: '¿Eliminar permanentemente?',
  NLSManageFieldBoard: 'Tablero',
  NLSManageFieldTargetBoard: 'Tablero objetivo',
  NLSManageItemFallback: 'ítem',
  NLSManageItemTitleFallback: '(sin título)',
  NLSManageKindGoal: 'meta',
  NLSManageKindGoalPlural: 'metas',
  NLSManageKindItem: 'elemento',
  NLSManageKindItems: 'elementos',
  NLSManageKindSubtask: 'subtarea',
  NLSManageKindTask: 'tarea',
  NLSManageKindTaskPlural: 'tareas',
  NLSManageStatusCloseAbortedKeepEditing: 'Cierre abortado: los ítems marcados "Seguir editando" permanecen abiertos.',
  NLSManageStatusCouldNotSavePending: 'No se pudieron guardar los ítems pendientes.',
  NLSManageStatusDiscarded: 'Descartado.',
  NLSManageStatusMoveFailed: 'El movimiento falló.',
  NLSManageStatusMovedOutOfBin: 'Movido {title} fuera del Contenedor.',
  NLSManageStatusPendingDiscarded: 'Cambios pendientes descartados.',
  NLSManageStatusPendingDiscardedNothingSaved: 'Cambios pendientes descartados (nada se guardó esta sesión).',
  NLSManageStatusReverted: 'Revertido.',
  NLSManageStatusSaveFailed: 'Guardado fallido: {reason}',
  NLSManageStatusSaved: 'Guardado.',
  NLSManageStatusSavedCount: 'Guardado {count} ítems.',
  NLSManageTitleBinItemNotFound: 'Ítem no encontrado',
  NLSManageTitleClipboardEmpty: 'Portapapeles vacío',
  NLSManageTitleCopyShortcut: 'Copiar (Cmd/Ctrl+C)',
  NLSManageTitleCutShortcut: 'Cortar (Cmd/Ctrl+X)',
  NLSManageTitleDeleteSelectTarget: 'Selecciona una meta / tarea / subtarea para eliminar',
  NLSManageTitleManage: 'Gestionar',
  NLSManageTitlePasteShortcut: 'Pegar (Cmd/Ctrl+V)',
  NLSManageTitleReview: 'Revisión',
  NLSManageTitleSwitchBoard: 'Cambiar a vista de Tablero',
  NLSManageTitleSwitchReview: 'Cambiar a vista de Revisión',
  NLSManageTitleBlockedEditField: 'Edita un campo antes de guardar este borrador.',
  NLSManageTitleBlockedFixItems: 'Corrige los ítems marcados "necesita atención" antes de guardar.',
  NLSManageTitleDiscardAllSession: 'Descartar todo incluyendo lo guardado esta sesión',
  NLSManageTitleFixBeforeClosing: 'Corrige los ítems marcados "necesita atención" antes de cerrar.',
  NLSManageTitleFixBlockedBeforeSave: 'Corrige los ítems bloqueados antes de guardar',
  NLSManageTitleItemUnavailable: 'Este ítem ya no está disponible.',
  NLSManageTitleLockedEditing: 'Bloqueado - {name} está editando',
  NLSManageTitleNoChildItems: 'Sin ítems hijos',
  NLSManageTitleNoPending: 'Nada pendiente',
  NLSManageTitleNoPendingChildChanges: 'Sin cambios pendientes en ítems hijos',
  NLSManageTitleNoPendingItem: 'Sin cambios pendientes en este ítem',
  NLSManageTitleNoPendingSelection: 'Sin cambios pendientes en esta selección',
  NLSManageTitleNothingToDiscard: 'Nada para descartar',
  NLSManageTitlePerItemApplyClose: 'Aplicar elecciones y cerrar.',
  NLSManageTitlePerItemKeepOpen: 'El cierre abortará: los ítems marcados "Seguir editando" permanecerán abiertos para ti.',
  NLSManageTitlePerItemPickEveryRow: 'Elige una acción para cada fila primero.',
  NLSManageTitlePermanentDeleteCannotUndo: 'Eliminar permanentemente (no se puede deshacer)',
  NLSManageTitleSaveParentFirst: 'Guarda el padre primero',
  NLSManageTitleSelectItemFirst: 'Selecciona un ítem primero',
  NLSManageTitleSelectValidClipboardTarget: 'Selecciona un destino válido para el {kind} en el portapapeles',
  NLSManageUserTeammateFallback: 'un compañero de equipo',
  NLSChecklistActionAttachFiles: 'Adjuntar archivos',
  NLSChecklistActionCaptureCurrentLocation: 'Capturar ubicación actual',
  NLSChecklistActionClose: 'Cerrar',
  NLSChecklistActionCreateItem: 'Crear item',
  NLSChecklistActionDelete: 'Eliminar',
  NLSChecklistActionDeleteNode: 'Eliminar nodo',
  NLSChecklistActionDiscard: 'Descartar',
  NLSChecklistActionEdit: 'Editar',
  NLSChecklistActionOpenInCanvas: 'Abrir en lienzo',
  NLSChecklistActionRecordVideoMemo: 'Grabar Memo de Inspección en Video en Vivo',
  NLSChecklistActionReply: 'Responder',
  NLSChecklistActionReverse: 'Revertir',
  NLSChecklistActionSave: 'Guardar',
  NLSChecklistActionSaveLock: 'Guardar y bloquear',
  NLSChecklistActionSaveChanges: 'Guardar cambios',
  NLSChecklistActionSaving: 'Guardando...',
  NLSChecklistActionVouchCompletion: 'Avalar la finalización',
  NLSChecklistAriaClosePanel: 'Cerrar panel',
  NLSChecklistAriaDateJump: 'Saltar a la fecha',
  NLSChecklistAriaDeleteGate: 'Eliminar esta puerta',
  NLSChecklistAriaIncomingWireAnchor: 'Anclaje de cable entrante',
  NLSChecklistAriaOutgoingWireAnchor: 'Anclaje de cable saliente',
  NLSChecklistAriaPostUpdate: 'Publicar actualización',
  NLSChecklistAriaProofApprover: 'Aprobador de prueba',
  NLSChecklistAriaRecurringChecklist: 'Lista de verificación {cadence} recurrente',
  NLSChecklistAriaSpecificDate: 'Saltar a una fecha específica',
  NLSChecklistAriaSpecificWeek: 'Saltar a una semana específica',
  NLSChecklistAriaWeekJump: 'Saltar a la semana',
  NLSChecklistBoardNodeAssignBeforeWork: 'Asignar antes de trabajar',
  NLSChecklistBoardNodeAssignedTo: 'Asignado a {name}',
  NLSChecklistBoardNodeGateDrag: 'Puerta {gate} (arrastrar)',
  NLSChecklistBoardNodeGateOutput: 'Salida de puerta {gate}',
  NLSChecklistBoardNodeGateOutputHint: 'Arrastra desde aquí para conectar aguas abajo',
  NLSChecklistBoardNodeLockedBy: 'Bloqueado por {name}',
  NLSChecklistBoardNodeLockedByBlocker: 'Bloqueado por Bloqueador: {title}',
  NLSChecklistBoardNodePendingCosign: 'Pendiente de co-firma',
  NLSChecklistCardDraftUnsaved: 'Borrador sin guardar',
  NLSChecklistCardStatusDone: 'Hecho',
  NLSChecklistCardStatusOpen: 'Abierto',
  NLSChecklistCardUntitled: 'Checklist sin titulo',
  NLSChecklistCardUpdated: 'Actualizado {time}',
  NLSChecklistCardWeight: 'Peso {weight}',
  NLSChecklistCommentActionDelete: 'Eliminar',
  NLSChecklistCommentActionEdit: 'Editar',
  NLSChecklistCommentActionReply: 'Responder',
  NLSChecklistCommentDeleted: 'Comentario eliminado',
  NLSChecklistCommentMetaEdited: 'Editado',
  NLSChecklistCommentMetaReply: 'Respuesta',
  NLSChecklistCommentReactionCelebrate: 'Celebrar',
  NLSChecklistCommentReactionCheck: 'Verificar',
  NLSChecklistCommentReactionCount: 'Reacción {label} {count}',
  NLSChecklistCommentReactionEyes: 'Ojos',
  NLSChecklistCommentReactionHeart: 'Corazón',
  NLSChecklistCommentReactionNoCount: 'Reacción {label}',
  NLSChecklistCommentReactionThumbsUp: 'Pulgares arriba',
  NLSChecklistDetailActive: 'Activo',
  NLSChecklistDetailActivityHistory: 'Historial',
  NLSChecklistDetailActivityDiscussion: 'Actividad del Nodo y Discusión',
  NLSChecklistDetailAddTitleToCreate: 'Añadir un título para crear',
  NLSChecklistDetailAssignee: 'Asignado',
  NLSChecklistDetailAssigneeAria: 'Asignado de lista de verificación',
  NLSChecklistDetailChecklistDetails: 'Detalles de lista de verificación',
  NLSChecklistDetailCommentEditing: 'Editando comentario',
  NLSChecklistDetailCommentReplying: 'Respondiendo al comentario',
  NLSChecklistDetailCompletionPerInstance: 'La finalización es por instancia · los guardados de detalles pueden apuntar a una o futuras instancias',
  NLSChecklistDetailCreatedBy: 'Creado por',
  NLSChecklistDetailDependencies: 'Dependencias',
  NLSChecklistDetailDetails: 'Detalles',
  NLSChecklistDetailDraftBar: 'Nueva lista de verificación · Borrador',
  NLSChecklistDetailDraftFooter: 'Esta lista de verificación no se guardará hasta que presiones Guardar.',
  NLSChecklistDetailEmpty: 'Vacio',
  NLSChecklistDetailLoadingItem: 'Cargando ítem de lista de verificación...',
  NLSChecklistDetailNewChecklist: 'Nueva lista de verificación',
  NLSChecklistDetailNoChanges: 'Sin cambios para guardar',
  NLSChecklistDetailNoDiscussion: 'Sin conversacion.',
  NLSChecklistDetailNoRecordedActivity: 'Aún no hay actividad registrada.',
  NLSChecklistDetailOptions: 'Opciones',
  NLSChecklistDetailPostingUpdate: 'Publicando actualización',
  NLSChecklistDetailPostPlaceholder: 'Añade una actualización de nodo o menciona a un compañero de equipo',
  NLSChecklistDetailProofOfCompletion: 'Prueba de finalización',
  NLSChecklistDetailProofGated: 'Requiere prueba',
  NLSChecklistDetailRecurrenceInstances: 'Recurrencia · Instancias',
  NLSChecklistDetailSaveUnlocksOptions: 'Guarda esta lista de verificación para desbloquear finanzas, dependencias y adjuntos.',
  NLSChecklistDetailSet: 'Listo',
  NLSChecklistDetailUnassigned: 'Sin asignar',
  NLSChecklistDetailUploadingAttachments: 'Subiendo adjuntos',
  NLSChecklistDetailUnavailable: 'Este ítem de lista de verificación ya no está disponible.',
  NLSChecklistDetailUntitled: 'Sin título',
  NLSChecklistDependencyBlockedByEmpty: 'Nada bloquea este nodo.',
  NLSChecklistDependencyBlockedByTitle: 'bloqueado por',
  NLSChecklistDependencyBlockerForEmpty: 'Este nodo no bloquea nada.',
  NLSChecklistDependencyBlockerForTitle: 'bloquea a',
  NLSChecklistFieldBy: 'hasta',
  NLSChecklistFieldCompletionCriteria: 'Criterios de finalización',
  NLSChecklistFieldDated: 'Fecha',
  NLSChecklistFieldDescription: 'Descripción',
  NLSChecklistFieldDuration: 'Duracion',
  NLSChecklistFieldEndDate: 'Fecha de finalización',
  NLSChecklistFieldExpenseOutlay: 'Gasto',
  NLSChecklistFieldEstimatedHours: 'ETC (h)',
  NLSChecklistFieldFrom: 'Desde',
  NLSChecklistFieldOn: 'En',
  NLSChecklistFieldPlaceholderCompletion: 'Indica las condiciones que definen la finalización',
  NLSChecklistFieldPlaceholderDescription: 'Describe el trabajo a realizar',
  NLSChecklistFieldPlaceholderTitle: 'Título del ítem de lista de verificación',
  NLSChecklistFieldRiskResourceSummary: 'Resumen de Riesgos y Recursos',
  NLSChecklistFieldScheduleType: 'Tipo de programación',
  NLSChecklistFieldStartDate: 'Fecha de inicio',
  NLSChecklistFieldTimeFrom: 'desde',
  NLSChecklistFieldTimeTo: 'hasta',
  NLSChecklistFieldTimeWindow: 'Ventana horaria',
  NLSChecklistFieldTitle: 'Título',
  NLSChecklistFieldWeight: 'Peso',
  NLSChecklistKindDaily: 'Diario',
  NLSChecklistKindWeekly: 'Semanal',
  NLSChecklistOccurrenceArchived: 'Archivado',
  NLSChecklistOccurrenceArchivedBeyondParent: 'Archivado · más allá del rango del padre',
  NLSChecklistOccurrenceArchivedTooltip: 'Ocurrencia archivada - el rango del padre ha pasado.',
  NLSChecklistOccurrenceCompleted: 'Completado {time}',
  NLSChecklistOccurrenceCompletedBy: 'Completado por {name}',
  NLSChecklistOccurrenceCompletedByArchived: 'Completado por {name} · archivado',
  NLSChecklistOccurrenceDailyHistory: 'Historial diario',
  NLSChecklistOccurrenceNotCompleted: 'No completado',
  NLSChecklistOccurrencePast: 'Ocurrencia pasada',
  NLSChecklistOccurrenceThisWeek: 'Esta semana',
  NLSChecklistOccurrenceToday: 'Hoy',
  NLSChecklistOccurrenceUpcoming: 'Proximo',
  NLSChecklistOccurrenceUpcomingTooltip: 'Próximo - el rango del padre aún no ha comenzado.',
  NLSChecklistOccurrenceWeeklyHistory: 'Historial semanal',
  NLSChecklistProofAutoComplete: 'Autocompletar al subir',
  NLSChecklistProofApprover: 'Aprobador',
  NLSChecklistProofApproverHelpAssigned: 'El ítem se mueve a Evaluación al subir prueba y solo el aprobador puede completarlo.',
  NLSChecklistProofApproverHelpAuto: 'Sin aprobador - subir la prueba completa el ítem automáticamente.',
  NLSChecklistProofDropFile: 'Suelta prueba o haz clic',
  NLSChecklistProofEnforceLocation: 'Requerir Registro de Ubicación Local',
  NLSChecklistProofFile: 'Prueba',
  NLSChecklistProofFileRequired: 'Prueba requerida',
  NLSChecklistProofFileAttached: 'Prueba adjunta',
  NLSChecklistProofLocationGate: 'Puerta ubicacion',
  NLSChecklistProofOptional: 'opcional',
  NLSChecklistProofPeerVerification: 'Verificacion par',
  NLSChecklistProofPeerVerificationHelp: 'Avalar la finalización física de este ayudante. El aumento de fiabilidad se aplica inmediatamente.',
  NLSChecklistProofAssignedHelper: 'Ayudante asignado',
  NLSChecklistProofPlayMemo: 'Reproducir memo',
  NLSChecklistProofRecordMemo: 'Grabar memo',
  NLSChecklistProofRecorded: 'Grabado',
  NLSChecklistProofRecording: 'Grabando...',
  NLSChecklistProofRemoveProof: 'Eliminar prueba',
  NLSChecklistProofStopRecording: 'Detener grabación',
  NLSChecklistProofThirdPartyRequired: 'Se requiere verificación de terceros.',
  NLSChecklistProofVideoMemo: 'Memo video',
  NLSChecklistProofVideoInspectionMemo: 'Memo de inspección de video',
  NLSChecklistProofVideoReady: 'Listo',
  NLSChecklistProofVideoStart15s: 'Iniciar grabación de 15s',
  NLSChecklistProofVoiceNoMemo: 'Sin memo',
  NLSChecklistProofVoiceRecording: 'Grabando',
  NLSChecklistShellJumpThisWeek: 'Esta semana',
  NLSChecklistShellAlreadyThisWeek: 'Ya estas en esta semana',
  NLSChecklistShellAlreadyToday: 'Ya estas en hoy',
  NLSChecklistShellAriaCanvasView: 'Vista de lienzo',
  NLSChecklistShellAriaOccurrenceNavigation: 'Navegación de ocurrencia',
  NLSChecklistShellAriaPage: 'Listas de verificación',
  NLSChecklistShellEmptyNoBoard: 'Abre un Tablero / Meta / Tarea desde la barra lateral para ver sus listas de verificación aquí.',
  NLSChecklistShellEmptyNoWorkspace: 'Abre un espacio de trabajo para ver las listas de verificación.',
  NLSChecklistShellLoadingCanvas: 'Cargando lienzo...',
  NLSChecklistShellRecurringSettings: 'Configuraciones recurrentes',
  NLSChecklistShellSubtitle: 'Tableros y flujos',
  NLSChecklistShellTitle: 'Listas de verificación',
  NLSChecklistShellJumpThisWeekAria: 'Ir a esta semana',
  NLSChecklistShellJumpToday: 'Hoy',
  NLSChecklistShellJumpTodayAria: 'Ir a hoy',
  NLSChecklistShellNextDay: 'Dia siguiente',
  NLSChecklistShellNextWeek: 'Semana siguiente',
  NLSChecklistShellPreviousDay: 'Dia anterior',
  NLSChecklistShellPreviousWeek: 'Semana anterior',
  NLSChecklistStatusClear: 'Libre',
  NLSChecklistStatusOpen: 'Abierto',
  NLSChecklistStatusBlocked: 'Bloqueado',
  NLSChatActionAttachFiles: 'Adjuntar archivos',
  NLSChatActionDelete: 'Eliminar',
  NLSChatActionEdit: 'Editar',
  NLSChatActionSendMessage: 'Enviar mensaje',
  NLSChatActionTranslate: 'Traducir',
  NLSChatActionUndoDelete: 'Deshacer eliminación',
  NLSChatComposerArchivedPlaceholder: 'Canal archivado',
  NLSChatComposerLockedPlaceholder: 'Esperando a una persona más',
  NLSChatComposerMessageAllPlaceholder: 'Mensaje a todos los chats',
  NLSChatEmptyNoMessages: 'Aún no hay mensajes en este canal.',
  NLSChatLabelActive: 'Activo',
  NLSChatLabelArchive: 'Archivo',
  NLSChatLabelChannels: 'Canales',
  NLSChatLabelChatsDiscussions: 'Chats y conversaciones',
  NLSChatLabelMembers: 'Miembros',
  NLSChatLabelTags: 'Etiquetas',
  NLSChatLabelYou: 'Tú',
  NLSChatMessageDeleted: 'Este mensaje fue eliminado.',
  NLSUploadViewAllUploadsLabel: 'Todas las subidas',
  NLSUploadViewAllUploadsDescription: 'Registro de artefactos',
  NLSUploadViewAiMagicUploadsLabel: 'Subidas de AI Magic',
  NLSUploadViewAiMagicUploadsDescription: 'Archivos privados de AI Magic',
  NLSUploadViewChatUploadsLabel: 'Subidas de chat',
  NLSUploadViewChatUploadsDescription: 'Archivos compartidos en chat',
  NLSUploadViewChecklistUploadsLabel: 'Listas de verificación',
  NLSUploadViewChecklistUploadsDescription: 'Pruebas y notas de voz',
  NLSUploadViewMeetingUploadsLabel: 'Subidas de reuniones',
  NLSUploadViewMeetingUploadsDescription: 'Documentos adjuntos a reuniones',
  NLSUploadViewBatchQueuesLabel: 'Colas por lote',
  NLSUploadViewBatchQueuesDescription: 'Lotes activos y pendientes',
  NLSUploadViewSyncSchedulerLabel: 'Programador',
  NLSUploadViewSyncSchedulerDescription: 'Ejecuciones programadas',
  NLSUploadViewStorageAnalyticsLabel: 'Analítica',
  NLSUploadViewStorageAnalyticsDescription: 'Uso y desglose del plan',
  NLSUploadNavLockedTitle: 'Limpia el filtro de artefacto para navegar.',
  NLSUploadLabelUnlimited: 'Ilimitado',
  NLSUploadLabelPending: 'Pendiente',
  NLSUploadLabelPendingDate: 'Fecha pendiente',
  NLSUploadCountFileOne: '{count} archivo',
  NLSUploadCountFileMany: '{count} archivos',
  NLSUploadCountUploadOne: '{count} subida',
  NLSUploadCountUploadMany: '{count} subidas',
  NLSUploadCountArtifactOne: '{count} artefacto',
  NLSUploadCountArtifactMany: '{count} artefactos',
  NLSUploadCountProviderOne: '{count} proveedor',
  NLSUploadCountProviderMany: '{count} proveedores',
  NLSUploadCountChecklistOne: '{count} lista de verificación',
  NLSUploadCountChecklistMany: '{count} listas de verificación',
  NLSUploadArtifactCategoryChatAttachment: 'Adjunto de chat',
  NLSUploadArtifactCategoryAiMagicUpload: 'Subida de AI Magic',
  NLSUploadArtifactCategoryFormResponse: 'Respuesta de formulario',
  NLSUploadArtifactCategoryChecklistProof: 'Prueba de checklist',
  NLSUploadArtifactCategoryVoiceMemo: 'Nota de voz',
  NLSUploadArtifactCategoryDesignAsset: 'Recurso de diseño',
  NLSUploadArtifactCategoryDriveReference: 'Referencia de Drive',
  NLSUploadArtifactCategoryMeetingDocument: 'Documento de reunión',
  NLSUploadActionBatchUpload: 'Carga por lotes',
  NLSUploadActionSyncing: 'Sincronizando...',
  NLSUploadActionSyncAll: 'Sincronizar todo',
  NLSUploadActionManagePlan: 'Gestionar plan',
  NLSUploadAriaWorkspaceUploadHub: 'Centro de carga del espacio de trabajo',
  NLSUploadAriaSections: 'Secciones del Centro de Carga',
  NLSUploadAriaCloseSelectionDetails: 'Cerrar detalles de selección',
  NLSUploadAriaSelectionDetails: 'Detalles de selección',
  NLSUploadIdentityTitle: 'Centro de Carga',
  NLSUploadIdentitySubtitle: 'Bóveda de artefactos',
  NLSUploadChecklistTypeAll: 'Todo',
  NLSUploadChecklistTypeDaily: 'Diario',
  NLSUploadChecklistTypeWeekly: 'Semanal',
  NLSUploadChecklistRecurringDaily: 'Diario recurrente',
  NLSUploadChecklistRecurringWeekly: 'Semanal recurrente',
  NLSUploadChecklistKindProof: 'Pruebas',
  NLSUploadChecklistKindVoiceMemo: 'Notas de voz',
  NLSUploadChecklistKindProofShort: 'prueba',
  NLSUploadChecklistKindMemoShort: 'nota',
  NLSFormsIdentityTitle: 'Formularios',
  NLSFormsIdentitySubtitle: 'Motor de captura',
  NLSFormsAriaWorkspace: 'Espacio de formularios',
  NLSFormsAriaNavigation: 'Navegación de formularios',
  NLSFormsSectionHubLabel: 'Formularios',
  NLSFormsSectionHubTone: 'Definiciones',
  NLSFormsSectionTemplatesLabel: 'Plantillas',
  NLSFormsSectionTemplatesTone: 'Kits reutilizables',
  NLSFormsSectionDraftsLabel: 'Borradores',
  NLSFormsSectionDraftsTone: 'En progreso',
  NLSFormsSectionArchiveLabel: 'Archivo',
  NLSFormsSectionArchiveTone: 'Definiciones guardadas',
  NLSFormsSectionAssignLabel: 'Asignar',
  NLSFormsSectionAssignTone: 'Solicitudes',
  NLSFormsSectionAssignedLabel: 'Para ti',
  NLSFormsSectionAssignedTone: 'Cola de respuesta',
  NLSFormsSectionResponsesLabel: 'Respuestas',
  NLSFormsSectionResponsesTone: 'Registro',
  NLSFormsSectionSettingsLabel: 'Ajustes',
  NLSFormsSectionSettingsTone: 'Política',
  NLSFormsActionCreateNewForm: 'Crear formulario',
  NLSFormsActionExplore: 'Explorar',
  NLSFormsActionBackToForms: 'Volver a formularios',
  NLSFormsActionRequestMembers: 'Solicitar',
  NLSFormsActionOpenLiveForm: 'Abrir formulario',
  NLSFormsActionSubmitAnother: 'Enviar otra respuesta',
  NLSFormsActionSubmitResponse: 'Enviar respuesta',
  NLSFormsActionSubmitting: 'Enviando...',
  NLSFormsActionSaveForm: 'Guardar formulario',
  NLSFormsActionSaving: 'Guardando...',
  NLSFormsActionUseTemplate: 'Usar plantilla',
  NLSFormsActionOpenTemplateFactory: 'Abrir Fábrica de Plantillas',
  NLSFormsActionAssignForm: 'Asignar formulario',
  NLSFormsActionAssigning: 'Asignando...',
  NLSFormsActionTagAndAssign: 'Etiquetar y asignar',
  NLSFormsActionSendRequest: 'Enviar solicitud',
  NLSFormsActionSendRequests: 'Enviar solicitudes',
  NLSFormsActionSending: 'Enviando...',
  NLSFormsActionExportLatestResponse: 'Exportar última respuesta',
  NLSFormsActionImportDefinition: 'Importar definición',
  NLSFormsActionConnectToEnable: 'Conectar para habilitar',
  NLSFormsActionGenerateInsight: 'Generar visión',
  NLSFormsDialogDirtyTitle: 'Cambios sin guardar',
  NLSFormsDialogDirtyMessage: '¿Guardar este borrador antes de salir del constructor?',
  NLSFormsDialogDeleteTitle: '¿Eliminar definición archivada?',
  NLSFormsDialogDeleteMessage: 'La definición del formulario se eliminará permanentemente. Los registros de respuesta histórica permanecen preservados para la gobernanza.',
  NLSFormsStatusDraft: 'Borrador',
  NLSFormsStatusActive: 'Activo',
  NLSFormsStatusArchived: 'Archivado',
  NLSFormsStatusPending: 'Pendiente',
  NLSFormsStatusCompleted: 'Completado',
  NLSFormsStatusCancelled: 'Cancelado',
  NLSFormsStatusExpired: 'Vencido',
  NLSFormsStatusReviewed: 'Revisado',
  NLSFormsStatusExported: 'Exportado',
  NLSFormsLabelAll: 'Todo',
  NLSFormsLabelAllStatuses: 'Todos',
  NLSFormsLabelAllItems: 'Todos',
  NLSFormsLabelFields: 'campos',
  NLSFormsLabelResponsesOne: '{count} respuesta',
  NLSFormsLabelResponsesMany: '{count} respuestas',
  NLSFormsLabelRequired: 'Obligatorio',
  NLSFormsLabelSelectOption: 'Seleccionar una opción',
  NLSFormsLabelNoResponse: 'Sin respuesta',
  NLSFormsLabelYes: 'Sí',
  NLSFormsLabelNoFilesUploaded: 'No se han subido archivos',
  NLSFormsFileChooseUpToOne: 'Elige hasta {count} archivo',
  NLSFormsFileChooseUpToMany: 'Elige hasta {count} archivos',
  NLSFormsLabelAttachmentUnavailable: 'Adjunto no disponible.',
  NLSFormsLabelPendingTimestamp: 'Marca de tiempo pendiente',
  NLSFormsModePreview: 'Vista previa',
  NLSFormsModeFill: 'Completar',
  NLSFormsModeResponses: 'Respuestas',
  NLSFormsFieldTypeText: 'Texto',
  NLSFormsFieldTypeParagraph: 'Párrafo',
  NLSFormsFieldTypeNumber: 'Número',
  NLSFormsFieldTypeDate: 'Fecha',
  NLSFormsFieldTypeDropdown: 'Desplegable',
  NLSFormsFieldTypeCheckbox: 'Casilla',
  NLSFormsFieldTypeFileUpload: 'Archivo',
  NLSFormsBuilderMode: 'Modo constructor',
  NLSFormsLoadingForm: 'Cargando formulario...',
  NLSFormsLoadingBuilder: 'Cargando constructor...',
  NLSFormsLoadingForms: 'Cargando formularios...',
  NLSFormsLoadingResponses: 'Cargando respuestas...',
  NLSFormsEmptyFormUnavailableTitle: 'Formulario no disponible',
  NLSFormsEmptyFormUnavailableBody: 'No se pudo cargar la definición.',
  NLSFormsEmptyNoResponsesYetTitle: 'Aún no hay respuestas',
  NLSFormsEmptyNoResponsesYetBody: 'Los registros enviados aparecerán aquí para revisión.',
  NLSFormsToastSaved: 'Formulario guardado en el espacio de trabajo.',
  NLSFormsToastArchived: 'Formulario archivado. Las respuestas permanecen disponibles.',
  NLSFormsToastDeleted: 'Definición archivada eliminada. Las respuestas históricas fueron retenidas.',
  NLSMeetingsIdentityTitle: 'Reuniones',
  NLSMeetingsIdentitySubtitle: 'Coordinación',
  NLSMeetingsAriaWorkspace: 'Espacio de reuniones',
  NLSMeetingsAriaScheduler: 'Programador de reuniones',
  NLSMeetingsAriaMode: 'Modo de reunión',
  NLSMeetingsAriaActions: 'Acciones de la reunión',
  NLSMeetingsSectionScheduleLabel: 'Agenda',
  NLSMeetingsSectionScheduleTone: 'Calendario',
  NLSMeetingsSectionHuddleLabel: 'Reunión rápida',
  NLSMeetingsSectionHuddleTone: 'Presencia',
  NLSMeetingsSectionMeetingLabel: 'Reuniones',
  NLSMeetingsSectionMeetingRoomLabel: 'Sala',
  NLSMeetingsSectionMeetingTone: 'Unirse',
  NLSMeetingsViewDay: 'Día',
  NLSMeetingsViewWeek: 'Semana',
  NLSMeetingsViewMonth: 'Mes',
  NLSMeetingsActionScheduleMeeting: 'Programar',
  NLSMeetingsActionStartHuddle: 'Iniciar huddle',
  NLSMeetingsActionJoinRoom: 'Unirse',
  NLSMeetingsActionNewMeeting: 'Nueva reunión',
  NLSMeetingsActionJoin: 'Unirse',
  NLSMeetingsActionJoinMeeting: 'Unirse',
  NLSMeetingsActionJoinHuddle: 'Entrar huddle',
  NLSMeetingsActionJoinHuddleMeeting: 'Unirse a reunión rápida',
  NLSMeetingsActionOpening: 'Abriendo',
  NLSMeetingsActionDocs: 'Documentos',
  NLSMeetingsActionTranscribe: 'Transcribir',
  NLSMeetingsActionCancel: 'Cancelar',
  NLSMeetingsActionSaveMeeting: 'Guardar reunión',
  NLSMeetingsActionSaveSendUpdates: 'Guardar y avisar',
  NLSMeetingsActionUpdateNew: 'Avisar nuevos',
  NLSMeetingsActionUpdateAll: 'Avisar a todos',
  NLSMeetingsActionDiscard: 'Descartar',
  NLSMeetingsActionPeople: 'Personas',
  NLSMeetingsActionSchedule: 'Programar',
  NLSMeetingsActionDetails: 'Detalles',
  NLSMeetingsActionToday: 'Hoy',
  NLSMeetingsLabelMembers: 'Miembros',
  NLSMeetingsLabelPeople: 'Personas',
  NLSMeetingsLabelChannels: 'Canales',
  NLSMeetingsLabelMeetingHub: 'Centro reuniones',
  NLSMeetingsLabelMeetingDetails: 'Detalles',
  NLSMeetingsLabelWorkspaceStats: 'Estadísticas de reuniones del espacio de trabajo',
  NLSMeetingsLabelUpcoming: 'Próximas',
  NLSMeetingsLabelCalendar: 'Calendario',
  NLSMeetingsLabelHuddle: 'Reunión rápida',
  NLSMeetingsLabelMeetingOne: 'reunión',
  NLSMeetingsLabelMeetingMany: 'reuniones',
  NLSMeetingsLabelFromToday: 'desde hoy',
  NLSMeetingsLabelBusySlots: 'ocupados',
  NLSMeetingsLabelListening: 'escuchando',
  NLSMeetingsLabelSpeaking: 'hablando',
  NLSMeetingsLabelPresent: 'presente',
  NLSMeetingsLabelReady: 'Listo',
  NLSMeetingsLabelParticipants: 'Participantes',
  NLSMeetingsLabelLinkedChannels: 'Canales vinculados',
  NLSMeetingsLabelSharedAgenda: 'Agenda compartida',
  NLSMeetingsEmptyTimelineTitle: 'Nada programado aquí aún',
  NLSMeetingsEmptyTimelineCanSchedule: 'Arrastra en el calendario o toca Programar para añadir una reunión.',
  NLSMeetingsEmptyTimelineReadonly: 'No hay reuniones en este rango.',
  NLSMeetingsEmptyNoMeetingSelectedTitle: 'No se ha seleccionado ninguna reunión',
  NLSMeetingsEmptyNoMeetingSelectedBody: 'Elige una reunión del calendario para ver sus detalles, agenda y controles de unión.',
  NLSMeetingsEmptyNoMembersMatch: 'No hay miembros que coincidan con los filtros actuales.',
  NLSMeetingsEmptyNoChannels: 'Aún no hay canales.',
  NLSMeetingsEmptyNoHuddle: 'Aún no hay nadie en esta reunión rápida.',
  NLSMeetingsEmptyStreamEyebrow: 'Flujo de reuniones',
  NLSMeetingsEmptyStreamTitle: 'No hay reuniones programadas',
  NLSMeetingsEmptyStreamBody: 'Usa Magic Concierge para encontrar un espacio abierto y crear la primera sesión de comando.',
  NLSMeetingsReadinessChecking: 'Comprobando sincronización del calendario',
  NLSMeetingsReadinessOptional: 'Sincronización opcional',
  NLSMeetingsReadinessBody: 'Las reuniones funcionan localmente sin calendario. Conecta Google Calendar en Link Hub cuando desees sincronización externa de calendario.',
  NLSMeetingsReadinessOpenLinkHub: 'Abrir Link Hub',
  NLSMeetingsDialogDiscardTitle: '¿Descartar cambios en la reunión?',
  NLSMeetingsDialogDiscardMessage: 'Esta reunión tiene ediciones no guardadas. Guarda o descarta antes de cambiar de pantalla.',
  NLSAiAriaOpenChatHistory: 'Abrir historial',
  NLSAiAriaCloseChatHistory: 'Cerrar historial',
  NLSAiAriaChatHistory: 'Historial de IA',
  NLSAiAriaActionsFor: 'Acciones para {label}',
  NLSAiActionNewChat: 'Nuevo chat',
  NLSAiActionRename: 'Renombrar',
  NLSAiActionDelete: 'Eliminar',
  NLSAiActionAdd: 'Agregar',
  NLSAiActionRetry: 'Reintentar',
  NLSAiActionReject: 'Rechazar',
  NLSAiActionStop: 'Detener',
  NLSAiActionEdit: 'Editar',
  NLSAiActionSave: 'Guardar',
  NLSAiActionSaving: 'Guardando...',
  NLSAiActionSaved: 'Guardado',
  NLSAiActionDiscard: 'Descartar',
  NLSAiActionYesIAmSure: 'Si, estoy seguro',
  NLSAiActionReviewDependencies: 'Revisar dependencias',
  NLSAiActionReviewPatches: 'Revisar cambios',
  NLSAiActionReviewPatch: 'Revisar cambio',
  NLSAiActionMoveToManage: 'Mover a Manage',
  NLSAiActionCollapseGoal: 'Contraer objetivo',
  NLSAiActionExpandGoal: 'Expandir objetivo',
  NLSAiActionCollapseTask: 'Contraer tarea',
  NLSAiActionExpandTask: 'Expandir tarea',
  NLSAiActionCollapseSubtask: 'Contraer subtarea',
  NLSAiActionExpandSubtask: 'Expandir subtarea',
  NLSAiActionSnoozeSuggestion: 'Posponer sugerencia',
  NLSAiActionAcceptSuggestion: 'Aceptar sugerencia',
  NLSAiActionDismissSuggestion: 'Descartar sugerencia',
  NLSAiComposerAddContext: 'Agregar contexto',
  NLSAiComposerOptions: 'Opciones de AI Magic',
  NLSAiComposerContextCount: 'Contexto {count}/{limit}',
  NLSAiComposerAddToContext: 'Agregar al contexto',
  NLSAiComposerBack: 'Volver',
  NLSAiComposerAddPhotosFiles: 'Agregar fotos y archivos',
  NLSAiComposerAddPhotosFilesHint: 'Imagenes, PDF, documentos, hojas',
  NLSAiComposerAttachPublicLink: 'Adjuntar enlace publico',
  NLSAiComposerAttachPublicLinkHint: 'Line valida paginas HTTPS legibles',
  NLSAiComposerUseAppAsset: 'Usar archivo de la app',
  NLSAiComposerUseAppAssetHint: 'Referenciar una carga accesible',
  NLSAiComposerSelectTimelineItems: 'Seleccionar items',
  NLSAiComposerSelectedCount: 'Cualquier tablero - {count} seleccionados',
  NLSAiComposerOperatingMode: 'Modo operativo',
  NLSAiComposerPlanMode: 'Modo plan - Arquitecto IA',
  NLSAiComposerPlanModeHint: 'Estrategia de solo lectura; desmarca para crear trabajo en la app.',
  NLSAiComposerPastePublicLink: 'Pega un enlace HTTPS publico',
  NLSAiComposerChecking: 'Comprobando...',
  NLSAiComposerLineCanReadLink: 'Line puede leer este enlace.',
  NLSAiComposerLinkValidationPending: 'Agregar se activa tras validar.',
  NLSAiComposerLineCouldNotReachLink: 'Line no pudo abrir este enlace.',
  NLSAiStatusConfirmed: 'Confirmado',
  NLSAiStatusPendingApproval: 'Requiere aprobacion',
  NLSAiStatusPendingClarification: 'Falta detalle',
  NLSAiStatusRejected: 'Rechazado',
  NLSAiTierDraftedBy: 'Borrador de {tierLongLabel}',
  NLSAiLabelSystem: 'Sistema',
  NLSAiLabelYou: 'Tu',
  NLSAiLabelAttachmentUnavailable: 'Adjunto no disponible.',
  NLSAiAriaAttachedPreviews: 'Vistas adjuntas',
  NLSAiExecutionResultsAria: 'Resultados de ejecucion',
  NLSAiExecutionDetails: 'Detalles de ejecucion',
  NLSAiExecutionCompletedFraction: '{completed}/{total} completadas',
  NLSAiExecutionDone: 'Hecho',
  NLSAiExecutionFailed: 'Fallido',
  NLSAiQuickActionsAria: 'Acciones de propuesta',
  NLSAiClarificationFormAria: 'Formulario de aclaracion',
  NLSAiClarificationEyebrow: 'Line necesita un detalle',
  NLSAiClarificationSelectOption: 'Seleccionar...',
  NLSAiThinkingDefault: 'Line esta pensando',
  NLSAiSuggestionGapAnalysis: 'Analisis de brecha',
  NLSAiSuggestionPastContext: 'Contexto previo',
  NLSAiSuggestionAria: 'Sugerencia: {kind}',
  NLSAiAmbientSuggestionAria: 'Sugerencia de Line: {title}',
  NLSAiGoalTreeNoGoals: 'Aun no hay objetivos. Genera uno primero.',
  NLSAiGoalTreeNoChecklistItems: 'Sin checklist',
  NLSAiEditExistingAria: 'Editar un objetivo, tarea o subtarea',
  NLSAiEditExistingTitle: 'Editar existentes',
  NLSAiEditExistingMenuLabel: 'Editar existentes',
  NLSAiEditExistingSummary: 'Editar existentes - {count}/3 - un objetivo',
  NLSAiPendingTreeReviewSaveTitle: 'Revisar y guardar - objetivo primero',
  NLSAiPendingTreeSaveEditsTitle: 'Guardar cambios - objetivo primero',
  NLSAiDiscardSubtaskConfirm: 'Eliminar esta subtarea? No se puede deshacer.',
  NLSAiDiscardTaskConfirm: 'Eliminar esta tarea y sus subtareas? No se puede deshacer.',
  NLSAiDiscardGoalConfirm: 'Eliminar este objetivo y todo debajo? No se puede deshacer.',
  NLSAiToastTimelineSaved: 'Timeline guardado.',
  NLSAiToastChangesSaved: 'Cambios guardados.',
  NLSAiToastCouldNotSaveTimeline: 'No se pudo guardar el timeline.',
  NLSAiToastGenerationCleared: 'Generacion descartada.',
  NLSAiProposalReadyHeading: 'Listo para crear',
  NLSAiProposalTimelineBullet: 'Cronograma: {start} -> {end}',
  NLSAiProposalScopeBullet: 'Alcance: {scope}',
  NLSAiProposalTaskCountOne: '{count} tarea',
  NLSAiProposalTaskCountMany: '{count} tareas',
  NLSAiProposalSubtaskCountOne: '{count} subtarea',
  NLSAiProposalSubtaskCountMany: '{count} subtareas',
  NLSAiProposalChecklistCountOne: '{count} item de checklist',
  NLSAiProposalChecklistCountMany: '{count} items de checklist',
  NLSAiProposalBuildPrompt: 'Di "build it" o usa Crear abajo para mover esto a Manage. Di que cambiar y lo revisare.',
  NLSAiProposalChangingHint: 'Dime que cambiar y revisare esta propuesta.',
  NLSAiPreviewUnavailable: 'Esta vista previa ya no esta disponible. Envia la solicitud de nuevo.',
  NLSReportsTitleReports: 'Reportes',
  NLSReportsSubtitleAuditExports: 'Exportaciones de auditoría',
  NLSReportsActionEvidenceLibrary: 'Biblioteca de evidencia',
  NLSReportsActionNewReport: 'Nuevo reporte',
  NLSReportsActionRefresh: 'Actualizar',
  NLSReportsActionBack: 'Atrás',
  NLSReportsActionDownload: 'Descargar',
  NLSReportsActionDownloadLatest: 'Descargar último',
  NLSReportsActionGenerateWorkspaceReport: 'Generar reporte del espacio',
  NLSReportsActionGenerateReport: 'Generar reporte',
  NLSReportsActionPreview: 'Vista previa',
  NLSReportsActionRegenerate: 'Regenerar',
  NLSReportsActionRename: 'Renombrar',
  NLSReportsActionRevoke: 'Revocar',
  NLSReportsActionPrevious: 'Anterior',
  NLSReportsActionNext: 'Siguiente',
  NLSReportsFilterAll: 'Todo',
  NLSReportsLabelComplianceActivity: 'Cumplimiento y actividad',
  NLSReportsLabelGovernanceCenter: 'Centro de gobernanza',
  NLSReportsLabelFilters: 'Filtros',
  NLSReportsLabelExportedReports: 'Reportes exportados',
  NLSReportsLabelWorkspaceActivity: 'Actividad del espacio',
  NLSReportsLabelFullLogs: 'Registros completos',
  NLSReportsLabelLiveLedger: 'Ledger vivo',
  NLSReportsLabelReportProfile: 'Perfil del reporte',
  NLSReportsLabelScopeSelection: 'Selección de alcance',
  NLSReportsLabelReportCategory: 'Categoría del reporte',
  NLSReportsLabelTemplateSelection: 'Selección de plantilla',
  NLSReportsLabelAdvancedInstructions: 'Instrucciones IA avanzadas',
  NLSReportsLabelFiltersGovernance: 'Filtros y gobernanza',
  NLSReportsLabelExportFinalization: 'Exportar y finalizar',
  NLSReportsLabelCreditEstimate: 'Estimación de créditos',
  NLSReportsStatusPending: 'Pendiente',
  NLSReportsStatusLoadingReports: 'Cargando reportes...',
  NLSReportsStatusReportsRestricted: 'Generar reportes está restringido a admins',
  NLSReportsStatusNoReportsYet: 'Aún no hay reportes',
  NLSReportsStatusNoReportsBody: 'Genera el primer reporte desde datos vivos del timeline.',
  NLSReportsAuditErrorSignInAgain: 'Inicia sesión de nuevo para ver el Ledger.',
  NLSReportsAuditRetentionMinimalist: 'Cumplimiento minimalista',
  NLSReportsAuditRetentionEnterprise: 'Auditoría completa empresarial',
  NLSReportsAuditRetentionDays: 'Auditoría completa {days}d',
  NLSReportsAuditTabLiveLedger: 'Ledger vivo',
  NLSReportsAuditTabLiveLedgerDetail: 'Actividad gobernada actual',
  NLSReportsAuditTabFullLogs: 'Registros completos',
  NLSReportsAuditTabFullLogsDetail: 'Vista completa del ledger',
  NLSReportsAuditRequiresFullAudit: 'Requiere auditoría completa',
  NLSReportsAuditTabExportedReports: 'Reportes exportados',
  NLSReportsAuditTabExportedReportsDetail: 'Vault y jobs de exportación',
  NLSReportsGeneratedPrefix: 'Generado:',
  NLSReportsCategoryStatus: 'Estado',
  NLSReportsCategoryDependency: 'Dependencias',
  NLSReportsCategoryBudget: 'Presupuesto',
  NLSReportsCategoryResource: 'Recursos',
  NLSReportsCategoryVelocity: 'Velocidad',
  NLSReportsCategoryPerformance: 'Rendimiento',
  NLSReportsCategoryCompliance: 'Cumplimiento',
  NLSReportsCategoryUserActivity: 'Actividad de usuario',
  NLSReportsCategoryCustom: 'Personalizado',
  NLSReportsDepthEssential: 'Esencial',
  NLSReportsDepthBoardroom: 'Directorio',
  NLSReportsDestinationLocal: 'Descarga local',
  NLSLinkHubIdentitySubtitle: 'Conecta herramientas del equipo y sincroniza metadatos.',
  NLSLinkHubAriaIntegrationCategories: 'Categorías de integraciones',
  NLSLinkHubAriaConnectionDetails: 'Detalles de conexión',
  NLSLinkHubAriaCloseConnectionDetails: 'Cerrar detalles de conexión',
  NLSLinkHubCategoryAll: 'Todo',
  NLSLinkHubCategoryProjects: 'Proyectos',
  NLSLinkHubCategoryDocuments: 'Documentos',
  NLSLinkHubCategoryCalendar: 'Calendario',
  NLSLinkHubCategoryCommunication: 'Comunicación',
  NLSLinkHubCategoryTitleAll: 'Todas las integraciones',
  NLSLinkHubCategoryTitleProjects: 'Integraciones de proyectos',
  NLSLinkHubCategoryTitleDocuments: 'Integraciones de documentos',
  NLSLinkHubCategoryTitleCalendar: 'Integraciones de calendario',
  NLSLinkHubCategoryTitleCommunication: 'Integraciones de comunicación',
  NLSLinkHubLabelRegistryGroup: 'Grupo de registro',
  NLSLinkHubLabelLiveMetadata: 'Metadatos en vivo',
  NLSLinkHubLabelProvider: 'Proveedor',
  NLSLinkHubLabelConnectionDetails: 'Detalles de conexión',
  NLSLinkHubLabelStatus: 'Estado',
  NLSLinkHubLabelLastSync: 'Última sync',
  NLSLinkHubLabelProviderId: 'ID de proveedor',
  NLSLinkHubLabelRegistryPhase: 'Fase de registro',
  NLSLinkHubLabelRuntimeLifecycle: 'Ciclo de runtime',
  NLSLinkHubLabelAiUsable: 'Usable por IA',
  NLSLinkHubLabelNotAiUsable: 'No usable por IA',
  NLSLinkHubLabelAuthorizedScopes: 'Scopes autorizados',
  NLSLinkHubIntegrationCountOne: '{count} integración',
  NLSLinkHubIntegrationCountMany: '{count} integraciones',
  NLSLinkHubUsageConnectedPending: 'conectadas · {pending} pendientes',
  NLSLinkHubStatusConnected: 'Conectado',
  NLSLinkHubStatusAwaitingAuth: 'Esperando auth',
  NLSLinkHubStatusTierLimitReached: 'Límite de plan alcanzado',
  NLSLinkHubStatusConfigurationNeeded: 'Configuración necesaria',
  NLSLinkHubStatusRequiresAuth: 'Requiere auth',
  NLSLinkHubStatusChecking: 'Revisando...',
  NLSLinkHubRuntimeActive: 'Activo',
  NLSLinkHubRuntimeConnecting: 'Conectando',
  NLSLinkHubRuntimeReauthRequired: 'Reauth requerida',
  NLSLinkHubRuntimeDisconnected: 'Desconectado',
  NLSLinkHubRuntimeDisabled: 'Deshabilitado',
  NLSLinkHubRuntimeDegraded: 'Degradado',
  NLSLinkHubRuntimeRateLimited: 'Con límite de tasa',
  NLSLinkHubRuntimeFailed: 'Falló',
  NLSLinkHubRuntimeUnknown: 'Desconocido',
  NLSLinkHubRuntimeNoDiagnostics: 'Este proveedor aún no reporta diagnósticos de runtime.',
  NLSLinkHubRuntimeInfrastructureMissing: 'La infraestructura del proveedor no está configurada.',
  NLSLinkHubPhaseOne: 'Fase 1',
  NLSLinkHubPhaseTwo: 'Fase 2',
  NLSLinkHubPhaseRoadmap: 'Roadmap fase 2',
  NLSLinkHubPhaseTestingEnabled: 'Override de pruebas activo',
  NLSLinkHubActionManagePlan: 'Gestionar plan',
  NLSLinkHubActionConnect: 'Conectar',
  NLSLinkHubActionConnectProvider: 'Conectar proveedor',
  NLSLinkHubActionConnectNamedProvider: 'Conectar {name}',
  NLSLinkHubActionReauthenticate: 'Reautenticar',
  NLSLinkHubActionReauthenticateProvider: 'Reautenticar proveedor',
  NLSLinkHubActionOpeningProvider: 'Abriendo proveedor...',
  NLSLinkHubActionOpenDetails: 'Abrir detalles',
  NLSLinkHubActionSyncNow: 'Sincronizar ahora',
  NLSLinkHubActionSyncInProgress: 'Sincronización en curso...',
  NLSLinkHubActionRefreshing: 'Actualizando...',
  NLSLinkHubActionForceRefreshReadiness: 'Actualizar readiness',
  NLSLinkHubActionConnectWebhook: 'Conectar webhook',
  NLSLinkHubActionEncrypting: 'Cifrando...',
  NLSLinkHubActionSaveEncryptedWebhook: 'Guardar webhook cifrado',
  NLSLinkHubActionRevoking: 'Revocando...',
  NLSLinkHubActionRevokeAccess: 'Revocar acceso',
  NLSLinkHubCardOpenDetailsAria: 'Abrir detalles de conexión de {name}',
  NLSLinkHubCardCompleteProviderAuthorization: 'Completa la autorización del proveedor',
  NLSLinkHubCardUpgradePlanToConnect: 'Mejora el plan para conectar',
  NLSLinkHubCardRoadmapIntegration: 'Integración en roadmap',
  NLSLinkHubCardSecretsUnavailable: 'Secretos no disponibles',
  NLSLinkHubAdminRequiredManage: 'Se requiere rol admin para gestionar integraciones',
  NLSLinkHubAdminRequiredTitle: 'Admin requerido',
  NLSLinkHubAdminRequiredBody: 'Pide a un admin del espacio que conecte o revoque integraciones.',
  NLSLinkHubAdminRequiredRevoke: 'Se requiere rol admin para revocar acceso',
  NLSLinkHubConfigPhaseTwoBody: 'Este proveedor está listado para una fase futura de Link Hub.',
  NLSLinkHubConfigMissingBody: 'Faltan secretos o ajustes de runtime del proveedor.',
  NLSLinkHubInputSigningSecret: 'Secreto de firma',
  NLSLinkHubRevokeWarningBody: 'Revocar acceso detiene futuras syncs hasta volver a conectar el proveedor.',
  NLSLinkHubDialogRevokeTitle: '¿Revocar {provider}?',
  NLSLinkHubDialogRevokeMessage: 'Esto elimina el acceso guardado para la integración seleccionada.',
  NLSLinkHubEmptyNoIntegrationsTitle: 'No hay integraciones aquí',
  NLSLinkHubEmptyNoIntegrationsBody: 'Prueba otra categoría.',
  NLSLinkHubEmptySelectIntegrationTitle: 'Selecciona una integración',
  NLSLinkHubEmptySelectIntegrationBody: 'Elige un proveedor para revisar readiness, scopes y estado de sync.',
  NLSLinkHubEmptyNoScopesRecorded: 'Sin scopes registrados.',
  NLSLinkHubNoSuccessfulSyncYet: 'Sin sync exitosa aún',
  NLSLinkHubSyncJobCompleted: 'Job {id} · {status} · {count} cambios',
  NLSLinkHubCallbackSuccess: '{provider} conectado.',
  NLSLinkHubCallbackError: 'No se pudo completar OAuth. No se guardaron cambios de conexión.',
  NLSLinkHubToastDebugOAuthBlocked: 'Redirect OAuth deshabilitado mientras debug bypass está activo.',
  NLSLinkHubToastCouldNotInitiateOAuth: 'No se pudo iniciar OAuth.',
  NLSLinkHubToastAccessRevoked: 'Acceso de {provider} revocado.',
  NLSLinkHubToastCouldNotRevokeProvider: 'No se pudo revocar el proveedor.',
  NLSLinkHubToastDebugWebhookBlocked: 'Guardar webhook está deshabilitado mientras debug bypass está activo.',
  NLSLinkHubToastGenericWebhookConnected: 'Webhook genérico conectado.',
  NLSLinkHubToastCouldNotSaveWebhook: 'No se pudo guardar el webhook.',
  NLSLinkHubToastSyncQueued: 'Sync de {provider} en cola.',
  NLSLinkHubToastCouldNotQueueSync: 'No se pudo poner la sync en cola.',
  NLSLinkHubTeamRequiredEyebrow: 'Se requiere espacio de equipo',
  NLSLinkHubUnavailableTitle: 'Link Hub no está disponible',
  NLSLinkHubTeamRequiredBody: 'Las integraciones externas están restringidas a espacios de equipo.',
  NLSLinkHubRestrictedEyebrow: 'Restringido',
  NLSLinkHubAccessRequiredTitle: 'Se requiere acceso a Link Hub',
  NLSLinkHubAccessRequiredBody: 'La política de permisos del espacio no permite esta página.',
  NLSResourcesActionManagePlan: 'Gestionar plan',
  NLSResourcesBudgetSubtitle: 'Planificador financiero',
  NLSResourcesBudgetTitle: 'Presupuesto',
  NLSResourcesQuotaTabManagement: 'Gestión',
  NLSResourcesQuotaTargetWeightedProgress: 'Progreso ponderado',
  NLSResourcesQuotaTitle: 'Cuotas',
  NLSResourcesReadinessTitle: 'Preparación de recursos',
  NLSResourcesSignalBudgetRisk: 'Riesgo de presupuesto',
  NLSResourcesSignalQuotaImpact: 'Impacto en cuota',
  NLSResourcesSignalStockShort: 'Stock insuficiente',
  NLSResourcesStockStatusAvailable: 'Disponible',
  NLSResourcesStockStatusMaintenance: 'Mantenimiento',
  NLSMemberTabTodos: 'Tareas',
  NLSMemberTabBoard: 'Tablero',
  NLSMemberTabAiMagic: 'IA',
  NLSMemberTabControls: 'Controles',
  NLSMemberTabYourPage: 'Tu Página',
  NLSMemberSubtabStripboard: 'Tablero de tiras',
  NLSMemberSubtabReview: 'Revisar',
  NLSMemberSubtabFolder: 'Carpeta',
  NLSMemberSubtabHistory: 'Historial',
  NLSMemberSubtabCreate: 'Crear',
  NLSMemberSubtabExecute: 'Ejecutar',
  NLSMemberSubtabPulse: 'Pulso',
  NLSMemberSubtabForms: 'Formularios',
  NLSMemberSubtabSync: 'Sincronizar',
  NLSMemberSubtabAutomations: 'Automatizar',
  NLSMemberSubtabAudit: 'Auditoría',
  NLSMemberSubtabMembers: 'Miembros',
  NLSMemberControlsSectionMembers: 'Miembros',
  NLSMemberSubtabCalendar: 'Calendario',
  NLSMemberSubtabMeetings: 'Reuniones',
  NLSMemberAriaNavigation: 'Navegación de miembros',
  NLSMemberAriaTabs: 'Pestañas de miembros',
  NLSMemberAriaBoardSections: 'Secciones del tablero',
  NLSMemberAriaNexusSections: 'Secciones Nexus',
  NLSMemberAriaAiSections: 'Secciones de AI Magic',
  NLSMemberAriaControlSections: 'Secciones de control',
  NLSMemberAriaOpenMenu: 'Abrir menú',
  NLSMemberAriaOpenNotifications: 'Abrir notificaciones',
  NLSMemberAriaUnread: 'no leído',
  NLSMemberWorkspaceEyebrow: 'Espacio de trabajo del miembro',
  NLSMemberContextEyebrow: 'Contexto',
  NLSMemberContextFallback: 'Selecciona tarjeta del tablero para ver detalles básicos.',
  NLSMemberLabelWorkspace: 'Espacio de trabajo',
  NLSMemberLabelMode: 'Modo',
  NLSMemberLabelType: 'Tipo',
  NLSMemberLabelStatus: 'Estado',
  NLSMemberModeMember: 'Miembro',
  NLSMemberPanelOverview: 'Visión general',
  NLSMemberPanelIncomingInvites: 'Invitaciones entrantes',
  NLSMemberPanelProfile: 'Perfil',
  NLSMemberPanelProfileEyebrow: 'Perfil del miembro',
  NLSMemberPanelSettings: 'Configuraciones del miembro',
  NLSMemberNotificationTitle: 'Notificaciones',
  NLSMemberNotificationClose: 'Cerrar notificaciones',
  NLSMemberNotificationClear: 'Limpiar',
  NLSMemberNotificationClearAll: 'Limpiar todo',
  NLSMemberNotificationEmpty: 'Estás al día.',
  NLSMemberNotificationSettings: 'Configuraciones de notificaciones',
  NLSMemberNotificationCleared: 'Notificación limpiada.',
  NLSMemberNotificationsCleared: 'Notificaciones limpiadas.',
  NLSMemberNotificationConfirmTitle: '¿Limpiar todas las notificaciones?',
  NLSMemberNotificationConfirmBody: 'Esto limpia la lista de notificaciones actual y no se puede deshacer.',
  NLSMemberPanelCommandPreferences: 'Preferencias de comando',
  NLSMemberStatusCreated: 'Creado',
  NLSMemberStatusAssigned: 'Asignado',
  NLSMemberStatusAccepted: 'Aceptado',
  NLSMemberStatusOngoing: 'En curso',
  NLSMemberStatusAssessing: 'Revisión',
  NLSMemberStatusCompleted: 'Completado',
  NLSMemberStatusNotRequired: 'No requerido',
  NLSMemberStatusPostponed: 'Aplazado',
  NLSMemberFilterAll: 'Todo',
  NLSMemberFilterAllHint: 'Cada lista de verificación en el tablero',
  NLSMemberStatusCreatedHint: 'Aún no asignado',
  NLSMemberStatusAssignedHint: 'Esperando aceptación',
  NLSMemberStatusAcceptedHint: 'Listo para comenzar',
  NLSMemberStatusOngoingHint: 'Actualmente en movimiento',
  NLSMemberStatusAssessingHint: 'Listo para revisión',
  NLSMemberStatusCompletedHint: 'Trabajo terminado',
  NLSMemberStatusNotRequiredHint: 'Omitido por regla',
  NLSMemberStatusPostponedHint: 'Trabajo aplazado',
  NLSMemberChecklistUntitled: 'Lista de verificación sin título',
  NLSMemberChecklistBoardParent: 'Lista de verificación del tablero',
  NLSMemberChecklistWorkspaceParent: 'Lista de verificación del espacio',
  NLSMemberChecklistNoDueDate: 'Sin fecha de vencimiento',
  NLSMemberBoardDailyChecklist: 'lista de verificación diaria',
  NLSMemberBoardWeeklyChecklist: 'lista de verificación semanal',
  NLSMemberBoardChecklist: 'lista de verificación',
  NLSMemberBoardRoot: 'Raíz',
  NLSMemberBoardNoDescription: 'No se añadió descripción.',
  NLSMemberBoardRequirementsAria: 'Requisitos de lista de verificación',
  NLSMemberBoardProofNeeded: 'Falta prueba',
  NLSMemberBoardLocationNeeded: 'Falta ubicación',
  NLSMemberBoardReviewPending: 'Revisión pendiente',
  NLSMemberBoardRecurring: 'Recurrente',
  NLSMemberBoardStatusMenu: 'Estado',
  NLSMemberBoardTitle: 'Flujo checklist',
  NLSMemberBoardEyebrow: 'Tablero de tiras',
  NLSMemberBoardSyncing: 'Sync...',
  NLSMemberBoardSynced: 'Sync ok',
  NLSMemberBoardMutable: 'Estados de lista de verificación mutables',
  NLSMemberBoardViewOnly: 'Solo ver',
  NLSMemberBoardAriaStripboard: 'Tablero de tiras del miembro',
  NLSMemberBoardAriaStatuses: 'Estados de lista de verificación',
  NLSMemberBoardAriaChangeStatus: 'Cambiar estado para {title}',
  NLSMemberBoardAriaStatusCount: '{label}, {count} ítems',
  NLSMemberBoardAriaStatusCountOne: '{label}, {count} ítem',
  NLSMemberBoardAriaItemsInStatus: '{label} ítems de lista de verificación',
  NLSMemberBoardEmptyStatus: 'No hay ítems de lista de verificación en {label}.',
  NLSMemberBoardToastStatusFailed: 'No se pudo actualizar el estado de la lista de verificación.',
  NLSMemberControlsEyebrow: 'Controles',
  NLSMemberControlsTitle: 'Controles del espacio de trabajo',
  NLSMemberControlsAuditRestrictedTitle: 'La auditoría está restringida',
  NLSMemberControlsAuditRestrictedBody: 'Se requiere acceso de Admin o Editor.',
  NLSMemberControlsInvitesRestrictedTitle: 'Las invitaciones están restringidas',
  NLSMemberControlsInvitesRestrictedBody: 'La gestión de invitaciones del espacio de trabajo requiere permiso.',
  NLSHelperTabTodos: 'Tareas',
  NLSHelperTabCalendar: 'Calendario',
  NLSHelperTabMeetings: 'Reuniones',
  NLSHelperTabControls: 'Controles',
  NLSHelperSubtabScan: 'Escanear',
  NLSHelperSubtabCount: 'Contar',
  NLSHelperSubtabMe: 'Yo',
  NLSHelperSubtabForms: 'Formularios',
  NLSHelperSubtabSync: 'Sincronizar',
  NLSHelperAriaNavigation: 'Navegación de Helper',
  NLSHelperAriaTabs: 'Pestañas de Helper',
  NLSHelperAriaOpenMenu: 'Abrir menú',
  NLSHelperAriaOpenNotifications: 'Abrir notificaciones',
  NLSHelperAriaUnread: 'no leído',
  NLSHelperPanelOverview: 'Visión general',
  NLSHelperPanelIncomingInvites: 'Invitaciones entrantes',
  NLSHelperPanelProfile: 'Perfil',
  NLSHelperPanelProfileEyebrow: 'Perfil de Helper',
  NLSHelperPanelSettings: 'Configuraciones de Helper',
  NLSHelperPanelCommandPreferences: 'Preferencias de comando',
  NLSHelperWaitingTitle: 'Esperando asignación',
  NLSHelperWaitingBody: 'Aún no perteneces a ningún espacio de trabajo. Una vez que un administrador del espacio de trabajo te invite, tus tareas aparecerán aquí.',
  NLSHelperPickWorkspaceBeforeScan: 'Elige un espacio de trabajo antes de escanear el inventario.',
  NLSHelperChatFocusRequired: 'Abre o enfoca una tarea antes de usar esta acción de chat.',
  NLSHelperToastEvidenceQueued: 'Evidencia en cola para sincronización.',
  NLSHelperToastDoneQueued: 'Hecho en cola para sincronización.',
  NLSHelperToastCommentQueued: 'Comentario en cola para sincronización.',
  NLSHelperToastInventoryScanFailed: 'Falló el escaneo del inventario.',
  NLSHelperTaskLoading: 'Cargando tus tareas...',
  NLSHelperTaskEmptyTitle: 'Todo listo',
  NLSHelperTaskEmptyBody: 'No hay tareas activas aquí. Cambia de espacio para ver más.',
  NLSHelperTaskDoneWhen: 'Hecho cuando',
  NLSHelperTaskProof: 'Prueba',
  NLSHelperTaskLocation: 'Ubicación',
  NLSHelperTaskDependencyLocked: 'Dependencia bloqueada',
  NLSHelperTaskBlocked: 'bloqueado',
  NLSHelperTaskSwipe: 'Desliza',
  NLSHelperTaskForDetails: 'para detalles',
  NLSHelperTaskGoToTask: 'Ir a la tarea {count}',
  NLSHelperTaskProofLocked: 'Prueba bloqueada',
  NLSHelperTaskUploadProof: 'Subir prueba',
  NLSHelperTaskNoProofNeeded: 'No se necesita prueba',
  NLSHelperTaskCheckIn: 'Registrar',
  NLSHelperTaskNoLocation: 'Sin ubicación',
  NLSHelperTaskProofUploadBlocked: 'Bloqueado por dependencia. Carga de prueba deshabilitada.',
  NLSHelperTaskProofAttached: 'Prueba adjunta ({name})',
  NLSHelperTaskProofAttachFailed: 'No se pudo adjuntar la prueba.',
  NLSHelperTaskLocationUnavailable: 'Ubicación no disponible en este dispositivo.',
  NLSHelperTaskLocating: 'Localizando...',
  NLSHelperTaskLocationPinned: 'Fijado {lat}, {lng}',
  NLSHelperTaskLocationRecordFailed: 'No se pudo registrar la ubicación.',
  NLSHelperTaskLocationPermissionDenied: 'Permiso de ubicación denegado.',
  NLSHelperReadinessTitle: 'Disponibilidad',
  NLSHelperReadinessReady: 'Listo para trabajar',
  NLSHelperReadinessNeedsAttention: 'Necesita atención',
  NLSHelperReadinessStockShort: 'Existencias bajas',
  NLSHelperReadinessBlockedCount: '{count} solicitud(es) abierta(s)',
  NLSHelperReadinessNeedMore: 'Necesita más',
  NLSHelperReadinessReport: 'Informar',
  NLSHelperBlockerReportTitle: 'Informar bloqueo',
  NLSHelperBlockerReportBody: 'Informa a los admins qué está deteniendo esta tarea.',
  NLSHelperBlockerReportPlaceholder: '¿Qué está bloqueando esto?',
  NLSHelperBlockerNeedMoreTitle: 'Necesita más existencias',
  NLSHelperBlockerNeedMoreBody: 'Envía la lista de escasez a admins y editores.',
  NLSHelperBlockerNeedMorePlaceholder: 'Nota opcional para la solicitud de existencias',
  NLSHelperBlockerShortages: 'Escasez',
  NLSHelperBlockerSending: 'Enviando...',
  NLSHelperBlockerSendReport: 'Enviar informe',
  NLSHelperBlockerSendNeedMore: 'Enviar solicitud',
  NLSHelperBlockerQueued: 'Solicitud en cola para sincronización.',
  NLSHelperBlockerQueueFailed: 'No se pudo poner en cola la solicitud.',
  NLSHelperControlsSubtabsAria: 'Subpestañas de controles',
  NLSHelperFormsAssignedForm: 'Formulario asignado',
  NLSHelperFormsDirectAssignment: 'Asignación directa',
  NLSHelperFormsBack: 'Atrás',
  NLSHelperFormsTitle: 'Formularios',
  NLSHelperFormsNoForms: 'Sin formularios',
  NLSHelperFormsCountOne: '{count} formulario',
  NLSHelperFormsCountMany: '{count} formularios',
  NLSHelperFormsStatusAria: 'Estado del formulario asignado',
  NLSHelperFormsStatusPending: 'Pendiente',
  NLSHelperFormsStatusCompleted: 'Completado',
  NLSHelperFormsStatusCancelled: 'Cancelado',
  NLSHelperFormsStatusExpired: 'Expirado',
  NLSHelperFormsStatusAll: 'Todos',
  NLSHelperFormsEmptyFilterTitle: 'No hay formularios en este filtro.',
  NLSHelperFormsEmptyFilterBody: 'Cambia el filtro de estado arriba para ver solicitudes completadas o canceladas.',
  NLSHelperFormsFromRequester: 'de {name}',
  NLSHelperScanTitle: 'Escanear',
  NLSHelperScanAction: 'Escanear',
  NLSHelperScanChooseTarget: 'Elegir destino',
  NLSHelperScanIn: 'Escanear entrada',
  NLSHelperScanOut: 'Escanear salida',
  NLSHelperScanSearchPlaceholder: 'Busca en espacio de trabajo, tareas, subtareas, listas de verificación',
  NLSHelperScanNoMatchingTarget: 'Sin destino.',
  NLSHelperScanIntro: 'Escanea un código de barras, luego elige dónde pertenece el escaneo.',
  NLSHelperScanTargetsBody: 'Espacio de trabajo, metas, tareas, subtareas y elementos asignados de lista de verificación son objetivos disponibles.',
  NLSHelperScanWorkspaceTitleFallback: 'Espacio de trabajo',
  NLSHelperScanWorkspaceSubtitle: 'Inventario global del espacio de trabajo',
  NLSHelperScanChecklistSubtitle: 'Lista de verificación · {status}',
  NLSHelperStockCountEyebrow: 'Auditoría de existencias',
  NLSHelperStockCountTitle: 'Contar inventario',
  NLSHelperStockCountScan: 'Escanear',
  NLSHelperStockCountManualPlaceholder: 'Ingresar código de barras',
  NLSHelperStockCountUseBarcodeAria: 'Usar código de barras',
  NLSHelperStockCountEmptyTitle: 'Escanea ítems para iniciar una ronda de conteo.',
  NLSHelperStockCountEmptyBody: 'Los conteos son sugerencias. Los admins aprueban antes de los cambios en el inventario.',
  NLSHelperStockCountRoundSummary: '{count} ítem(s) en cola - neto {delta}',
  NLSHelperStockCountSubmitting: 'Enviando',
  NLSHelperStockCountSubmit: 'Enviar conteo',
  NLSHelperStockCountRemoveAria: 'Quitar {name}',
  NLSHelperStockCountNote: 'Nota',
  NLSHelperStockCountCounted: 'Contado',
  NLSHelperStockCountSystemQuantity: 'Cantidad del sistema al escanear: {count}',
  NLSHelperStockCountUnknownBarcode: 'No se encontró ítem de inventario para {barcode}.',
  NLSHelperStockCountLookupFailed: 'No se pudo buscar el ítem de inventario.',
  NLSHelperStockCountQueued: 'Conteo de existencias en cola para revisión.',
  NLSHelperStockCountQueueFailed: 'No se pudo poner en cola el conteo de existencias.',
  NLSHelperQuotaEyebrow: 'Mi cuota',
  NLSHelperQuotaTitle: 'Progreso hoy',
  NLSHelperQuotaLoading: 'Cargando cuota...',
  NLSHelperQuotaLoadFailed: 'No se pudo cargar la cuota.',
  NLSHelperQuotaEmpty: 'No hay cuota activa asignada.',
  NLSHelperQuotaNoTargets: 'Esta cuota no tiene objetivos aún.',
  NLSHelperQuotaTodayTitle: 'Trabajo asignado de hoy añadiría',
  NLSHelperQuotaTodayEmpty: 'No hay trabajo asignado programado para hoy.',
  NLSHelperQuotaTargetTasks: 'tareas',
  NLSHelperQuotaTargetSales: 'ventas',
  NLSHelperQuotaTargetChecklists: 'listas de verificación',
  NLSHelperQuotaTargetWeighted: 'progreso ponderado',
  NLSHelperReliabilityEyebrow: 'Fiabilidad',
  NLSHelperReliabilityTitle: 'Avales y señales',
  NLSHelperReliabilityPending: 'Nuevo',
  NLSHelperReliabilityScans: 'Escaneos',
  NLSHelperReliabilityDone: 'Hecho',
  NLSHelperReliabilityVouches: 'Avales',
  NLSHelperReliabilityBlockers: 'Bloqueadores',
  NLSHelperReliabilityStreak: 'Señal de finalización',
  NLSHelperReliabilityStreakBody: '{count} completados en los últimos {days} días.',
  NLSHelperReliabilityStreakPending: 'Aún no se ha calculado la ventana de fiabilidad.',
  NLSHelperMeQuotaOffTitle: 'Cuota desactivada en este espacio',
  NLSHelperMeQuotaOffBody: 'Tu admin puede activarla en configuraciones.',
  NLSHelperMeQuotaRetry: 'No se pudo cargar tu cuota — toca para reintentar',
  NLSHelperMeReliabilityScansHint: 'Códigos de barras que has escaneado en esta ventana de 30 días.',
  NLSHelperMeReliabilityDoneHint: 'Tareas que has completado y aprobado.',
  NLSHelperMeReliabilityVouchesHint: 'Elogios que admins o compañeros registraron para tu trabajo.',
  NLSHelperMeReliabilityBlockersHint: 'Bloqueadores abiertos + resueltos que has informado.',
  NLSHelperMeReliabilityKicksInAfter: 'La puntuación de fiabilidad entra en vigor después de 5 tareas completadas. Estás en {count}/5.',
  NLSHelperReliabilityRecentBlockers: 'Bloqueadores recientes',
  NLSHelperReliabilityNoBlockers: 'No hay bloqueadores abiertos en tu trabajo actual.',
  NLSHelperFieldPassDelegate: 'Delegar esto a un Helper de Campo',
  NLSFieldPassQuickTitle: 'Field Pass Rápido',
  NLSFieldPassQuickBody: 'Crea un enlace de acceso de corta duración para este trabajo asignado.',
  NLSFieldPassQuickUntitledTarget: 'Tarea asignada',
  NLSFieldPassQuickNoTargets: 'Elige al menos un ítem asignado.',
  NLSFieldPassQuickExpiresLabel: 'Expira en',
  NLSFieldPassQuickExpires6h: '6 horas',
  NLSFieldPassQuickExpires12h: '12 horas',
  NLSFieldPassQuickExpires24h: '1 día',
  NLSFieldPassQuickExpires72h: '3 días',
  NLSFieldPassQuickDeleteOnCompletion: 'Revocar cuando el trabajo asignado se complete',
  NLSFieldPassQuickCreate: 'Crear Field Pass',
  NLSFieldPassQuickCreating: 'Creando...',
  NLSFieldPassQuickCopied: 'Enlace de Field Pass copiado.',
  NLSFieldPassQuickCreateFailed: 'No se pudo crear el Field Pass.',
  NLSFieldPassQuickCopyLink: 'Copiar enlace',
  NLSFieldPassQuickShareLink: 'Compartir enlace',
  NLSFieldPassQuickTargetEmailLabel: 'Dirección a (opcional)',
  NLSFieldPassQuickTargetEmailHint: 'Si se da, este Field Pass aparece en la bandeja de entrada de Explorar de ese usuario tras iniciar sesión. La URL de Field Pass sigue funcionando para cualquiera con el enlace.',
  NLSFieldPassAddressedTo: 'Dirigido a',
  NLSHelperSettingsTitle: 'Ajustes',
  NLSHelperSettingsCloseAria: 'Cerrar configuraciones',
  NLSHelperSettingsAccount: 'Cuenta',
  NLSHelperSettingsLanguage: 'Idioma',
  NLSHelperSettingsLanguageAria: 'Idioma del Helper',
  NLSHelperSettingsLoadingLanguages: 'Cargando idiomas...',
  NLSHelperSettingsTranslationCredits: 'La traducción es por mensaje y usa créditos del espacio de trabajo.',
  NLSHelperSettingsDelivery: 'Entrega',
  NLSHelperSettingsSigningOut: 'Cerrando sesión...',
  NLSHelperSettingsDialogAria: 'Configuraciones del Helper',
  NLSMobileSyncHelperHeroEyebrow: 'Sincronización de Helper',
  NLSMobileSyncMemberHeroEyebrow: 'Sincronización móvil',
  NLSMobileSyncSyncing: 'Sincronizando...',
  NLSMobileSyncSyncNow: 'Sincronizar ahora',
  NLSMobileSyncRetry: 'Reintentar sincronización',
  NLSMobileSyncDiscard: 'Descartar',
  NLSMobileSyncUseLatest: 'Usar última versión del Espacio',
  NLSMobileSyncOpenTask: 'Abrir Tarea',
  NLSMobileSyncPillOpen: 'Abrir centro de sincronización',
  NLSMobileSyncPillPendingCount: '{count} pendientes',
  NLSMobileSyncOperationsAria: 'Operaciones de sincronización móvil',
  NLSMobileSyncSyncedAtTime: 'Sincronizado a las {time}.',
  NLSMobileSyncHeldSafely: 'Guardado seguro en este dispositivo hasta sincronizar.',
  NLSMobileSyncSending: 'Enviando esta actualización al espacio de trabajo.',
  NLSMobileSyncMemberOfflinePolicy: 'Política sin conexión',
  NLSCapacitorRedirecting: 'Redirigiendo...',
  NLSOpsRequestKindReliefNeeded: 'Relevo necesario',
  NLSOpsRequestKindIncident: 'Incidente',
  NLSOpsRequestKindClientComplaint: 'Queja del cliente',
  NLSOpsRequestKindSupplyRequest: 'Solicitud de suministros',
  NLSOpsRequestKindPm: 'Mantenimiento preventivo',
  NLSOpsRequestKindCalibration: 'Calibración',
  NLSOpsReliefNeededTitle: 'Relevo necesario: {roleLabel} en {placeName} ({dayKey})',
  NLSOpsSitesPostsSubtitle: 'Puestos de guardia por sitio y turno · una ausencia genera una solicitud de relevo',
  NLSOpsSitesSelectSite: 'Seleccionar sitio',
  NLSOpsSitesDay: 'Día',
  NLSOpsSitesSelectShift: 'Seleccionar turno',
  NLSOpsSitesPostsBoardTitle: 'Puestos y relevos',
  NLSOpsSitesColPost: 'Puesto',
  NLSOpsSitesColNeeds: 'Necesidad',
  NLSOpsSitesColOnDuty: 'De servicio',
  NLSOpsSitesColState: 'Estado',
  NLSOpsSitesStateCovered: 'Cubierto',
  NLSOpsSitesStateShort: 'Incompleto',
  NLSOpsSitesStateReliefNeeded: 'Relevo necesario',
  NLSOpsSitesStateReliefAssigned: 'Relevo asignado',
  NLSOpsSitesNeedsFormat: '{count} {role}',
  NLSOpsSitesAbsentTag: 'ausente',
  NLSOpsSitesReliefInbox: 'Buzón de relevos',
  NLSOpsSitesReliefFootnote: 'Una ausencia en la lista genera automáticamente RELIEF_NEEDED y advierte sobre la cobertura (A6).',
  NLSOpsSitesFreeCandidates: 'Candidatos disponibles:',
  NLSOpsSitesOffToday: 'libre hoy',
  NLSOpsSitesAssignBtn: 'Asignar',
  NLSOpsSitesAssignCandidateBtn: 'Asignar a {name}',
  NLSOpsSitesAssignDialogTitle: 'Asignar relevo',
  NLSOpsSitesPrintPostSheet: 'Imprimir hoja de puestos',
  NLSOpsSitesNoPosts: 'No hay puestos de guardia configurados para este sitio.',
  NLSOpsSitesNoReliefNeeded: 'No se necesitan relevos.',
  NLSOpsSitesNoSites: 'No se encontraron sitios de clientes.',
  NLSOpsSitesNoShifts: 'No hay turnos disponibles.',
  NLSOpsSitesPostSheetTitle: 'Hoja de puestos · {siteName}',
  NLSOpsSitesPostSheetSubtitle: '{dayKey} · {shiftName}',
  NLSOpsSitesErrorStaleRequest: 'No se puede asignar relevo: la solicitud ya no está abierta.',
  NLSOpsSitesErrorOnLeave: 'No se puede asignar relevo: la persona está de permiso aprobado.',
  NLSOpsSitesErrorDoubleBooked: 'No se puede asignar relevo: la persona ya está asignada a este turno.',
  NLSOpsSitesErrorRoleCeiling: 'No se puede asignar relevo: el límite de rol del miembro impide la asignación.',
  NLSOpsSitesErrorGeneric: 'Error al asignar relevo.',
  NLSOpsSitesErrorNotFound: 'Registro o solicitud no encontrado.',
  NLSOpsSitesErrorMissingAttributes: 'La solicitud no incluye los atributos de relevo requeridos.',
  NLSOpsSitesErrorInactivePerson: 'No se puede asignar relevo: la persona está inactiva en el espacio de trabajo.',
  NLSOpsRequestsUnassigned: 'Sin asignar',
  NLSOpsRequestsDetailUnassigned: 'Sin asignar',
  NLSOpsSitesIncidentsSubtitle: 'Incidentes (restringidos) · quejas de clientes · solicitudes de suministros · auditorías de supervisión',
  NLSOpsSitesIncidentsTitle: 'Incidentes',
  NLSOpsSitesRestrictedTag: 'restringido',
  NLSOpsSitesAuditScoresTitle: 'Puntajes de auditoría',
  NLSOpsSitesSupervisorRegisterTag: 'registro del supervisor',
  NLSOpsSitesColSite: 'Sitio',
  NLSOpsSitesColLastAudit: 'Última auditoría',
  NLSOpsSitesColScore: 'Puntaje',
  NLSOpsSitesRecordAuditBtn: 'Registrar auditoría',
  NLSOpsSitesComplaintsSupplyTitle: 'Quejas y solicitudes de suministros',
  NLSOpsSitesNoIncidents: 'No hay incidentes registrados.',
  NLSOpsSitesNoComplaintsSupply: 'No hay quejas ni solicitudes de suministros.',
  NLSOpsSitesNoAudits: 'No hay auditorías registradas.',
  NLSOpsSitesNoAuditTemplate: 'Sin plantilla de auditoría de sitio del supervisor.',
  NLSOpsSitesOpenTemplatesBtn: 'Abrir plantillas',
} satisfies NlsStringMap

export default esStringsNls
